import Vue from 'vue'
import OrderFun from '../../util/orderFun'
import Picc from '../../util/pulicInsuranceOfPICC'
import staticData from '../../util/static-data';
import { trialControl } from '@/util/insuranc-profession-control'
import {
    _float,
    _for,
    _noValue,
    _cloneObj,
    _formatDate,
    _toJson,
    typeOf,
    getObjVal,

} from 'tools';
import {
    trace,
    getPageSettingsSeparateToProductMsg,
    getJobType,
} from '_libs/util';
import {
    checkAgeRestrictByJobType,
} from '@/util/insure-unit';
import { globalControlConfig } from '_libs/util/control'
import writeStoreNew from './writeStoreNew';
import { transformJg2SwimmingPoolInfo, transformSwimmingPoolInfo2Jg } from '@/mixin/special/special-80218';
import { cloneDeep, get } from 'lodash';
import { DEPRECATED_CLAUSES_IDS } from '@/util/GLOBAL';
import { checkPersonAgeError } from '@/util/person';
import { specialPersonValidateFuncMap } from '@/util/special';
import { getAvailablePlanCode } from '@/util/premiumRate';

function getEarliestBirthday(d, state) {
  if (!d) {
    return ''
  }
  let earliestBirthday = new Date(state.validStartDate);
  if (!earliestBirthday) {
    return ''
  }
  if (state.frontControlInfo.ageCheckType === 'orderCreateDay') {
      let date = new Date()
      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)
      earliestBirthday = date
  }
  earliestBirthday.setFullYear(earliestBirthday.getFullYear() - d - 1);
  earliestBirthday.setDate(earliestBirthday.getDate() + 1);
  return earliestBirthday.getTime();
}

function getLatestBirthday(d, state) {
  if (!d) {
    return ''
  }
  let latestBirthday = new Date(state.validStartDate);
  if (!latestBirthday) {
    return ''
  }
  // ===orderCreateDay 为投保日期
  if (state.frontControlInfo.ageCheckType === 'orderCreateDay') {
    let date = new Date()
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    latestBirthday = date
  }
  latestBirthday.setFullYear(latestBirthday.getFullYear() - d);
  return latestBirthday.getTime();
}

const writeStore = {
    state: {
        productAddress: {}, // 保存地址信息
        insureNameCheck: 0, // 投保时 团体名称 是否需要人工审核，1-需要审核，0-不需要审核
        groupIdCheck: 0, // 投保时 统一团体信用码 是否需要人工审核，1-需要审核，0-不需要审核
        isNoProfession: null,
        insureHouseArea: 1, // 经营面积
        freeOdds: 1,  // 免赔率系数 204
        base: null,
        front: null,
        frontControlInfo: null,
        minRoleNum: '',
        description: null,
        restrict: null,
        durationList: [],
        schemes: [],
        defaultPlan: null,  //默认的投保计划
        rules: [],
        dbList: null,   // 免赔额列表
        drList: null,   // 赔付比例列表
        ddrList: null,   // 伤残比例列表
        clausePremium: null,    // 费率表
        careerType: [],    // 所有的职业列别
        discountList: [],   // 折扣列表
        premiumRateList: [],   // 费率列表
        planCode: null,   // 方案code
        priceRate: null,   // 浮动的保费 与 当前区间 的比例
        ageRestrictType: null, // 年龄限制类型
        ageRestrictData: {},

        productId: null,
        duration: null,
        applyQuantity: 1,   // 投保份数
        validStartDate: '', // 保险起期
        validEndDate: '',   // 保险止期
        insurePeriod: 0, // 保险期间，根据保险止期和保险起期推算，如7006
        groupName: '',
        legalPersonName: '',
        groupCardType: '',
        groupCardId: '',
        imgList: [], // 团体证件图片
        authorizationBookList: [], // 投保声明与授权委托书
        // 上年保单
        lastYearPolicyUrl: [],
        // 5-6类被保险人工作现场/环境图片
        environmentUrl: [],
        pageSettingsSeparate: {},

        // 民宿信息
        'orderInfoExtend.guestRoomAmount': null, // 客房数量
        'orderInfoExtend.employeeAmount': null, // 雇员数量
        'orderInfoExtend.swimmingPoolAmount': null, // 游泳池数量
        'orderInfoExtend.parkingLotAmount': null, // 停车场车位数量
        'orderInfoExtend.businessArea': null, // 经营面积
        // 建工险新增
        premiumData: null,
        'constructionInfo.projectName': null, // 工程名称
        'constructionInfo.projectType': null, // 工程类型
        'constructionInfo.typeOfLabor': null, // 劳务分包类型
        'constructionInfo.constructionSquare': null, // 建筑面积
        'constructionInfo.projectCosts': null, // 工程造价
        'constructionInfo.constructionPeriod': null, // 施工工期
        'constructionInfo.constructionStartTime': null, // 施工起期
        'constructionInfo.constructionEndTime': null, // 施工止期
        'constructionInfo.notSafetySupervision': null, // 免安监证明
        'constructionInfo.constructionQualification': null, // 施工资质
        'constructionInfo.area': {
          provinceCode: '',
          provinceName: '',
          cityCode: '',
          cityName: '',
          countyCode: '',
          countyName: '',
          address: '',
        },
        'constructionInfo.materialImageUrls': [], // 材料影像件
        projectContractVideo: [], // 项目合同影像件
        constructionCertificate: [], // 施工资质证书
        'groupApplicant.constructionQualification': null, // 施工资质， 2026-06-10之后的都用上面那个建工险里的
        legalPersonCardUrls: [],

        addressSearchList: [],
        clausesShow: [], // 只做展示的责任
        clauseCode7002: false,

        'groupApplicant.setUpTime': null,        // 团体成立时间
        'groupApplicant.groupIdValidEndDate': null, // 营业执照止期
        'groupApplicant.groupCardLongTermEffective': 0, // 营业执照止期 - 长期有效
        'groupApplicant.concatCall': null,       // 团体联系人电话
        'groupApplicant.groupContact': null,     // 团体联系人
        'groupApplicant.groupNature': null,      // 单位性质
        'groupApplicant.groupNatureCode': null,  // 单位性质id
        'groupApplicant.groupEmail': null,       // 联系人邮箱
        'groupApplicant.totalEmployers': null,   // 上年末员工总数
        'groupApplicant.totalIncome': null,      // 上年度营业收入
        'groupApplicant.groupAssets': null,      // 上年末资产总额
        'groupApplicant.registersdFunds': null,      // 公司注册资金
        'groupApplicant.companyCategory': null,      // 企业类别
        'groupApplicant.contactCall': null,      // 联系人手机号
        'groupApplicant.landline': null,      // 联系人手机号
        'groupApplicant.contactCardId': null,    // 联系人身份证号
        'groupApplicant.address': null,          // 团体联系人详细地址
        'groupApplicant.residentProvince': null, // 省
        'groupApplicant.residentCity': null,     // 市
        'groupApplicant.residentDistrict': null, // 区
        'groupApplicant.residentProvinceName': null, // 省
        'groupApplicant.residentCityName': null,     // 市
        'groupApplicant.residentDistrictName': null, // 区
        'groupApplicant.zipCode': null,          // 邮政编码
        'groupApplicant.insureHouseAddress': null, //房屋地址
        'groupApplicant.insureHouseInfo': null,    //房屋地址省市区（中文）
        'groupApplicant.insureHouseProvince': null, //房屋地址省份
        'groupApplicant.insureHouseCity': null, //房屋地址市
        'groupApplicant.insureDistrict': null, //房屋地址区
        'groupApplicant.insureHouseProvinceName': null, //房屋地址省份
        'groupApplicant.insureHouseCityName': null, //房屋地址市
        'groupApplicant.insureDistrictName': null, //房屋地址区
        'groupApplicant.operatorRelation': null,          // 操作人和投保人关系

        /* 80212新增 */
        'groupApplicant.isHumanResources': null,  // 是否人力资源中介
        'groupApplicant.projectType': null,  // 项目类型
        'groupApplicant.setUpTimeType': null,  // 企业存续时间

        // 只有省市区的地址，不包含具体地址的地址组件字段
        'groupApplicant.otherProvinceName': null, //其他单位省名称
        'groupApplicant.otherCityName': null, //其他单位市名称
        'groupApplicant.otherDistrictName': null, //其他单位区名称
        'groupApplicant.otherProvince': null, //房屋地址区
        'groupApplicant.otherCity': null, //房屋地址区
        'groupApplicant.otherDistrict': null, //房屋地址区
        'groupApplicant.otherAddressName': null, //房屋地址 详细区域

        'groupApplicant.businessLicense': null, //营业执照
        'groupApplicant.insureHouseArea': null, //标的面积
        'groupApplicant.insureGroupCardId': null,  //被保人证件号码
        'groupApplicant.insureGroupName': null,  //被保人名称
        'groupApplicant.insureCompanyTypeCode': null, //被保人企业性质id
        'groupApplicant.insureCompanyType': '', //被保人企业性质
        'groupApplicant.businessArea': '', //团体经营范围
        'groupApplicant.industryInfos': null, //行业范围
        'groupApplicant.housingArea': '',
        'groupApplicant.legalPersonIdNo': '', // 法人身份证号

        'billInfoBean.billType': null,
        'billInfoBean.title': null,                // 发票抬头
        'billInfoBean.amount': null,               // 发票金额
        'billInfoBean.taxId': null,                // 纳税人识别号或统一社会信用代码
        'billInfoBean.mailAddress': null,          // 电子邮箱地址
        'billInfoBean.address': null,              // 收件地址
        'billInfoBean.contactPerson': null,        // 收件人
        'billInfoBean.contactTel': null,           // 联系电话
        'billInfoBean.province': null,
        'billInfoBean.city': null,
        'billInfoBean.zone': null,
        'billInfoBean.provinceCode': null,
        'billInfoBean.cityCode': null,
        'billInfoBean.zoneCode': null,
        'billInfoBean.taxTel': null,           // 税务登记电话
        'billInfoBean.taxName': null,           // 纳税人姓名
        'billInfoBean.taxBankName': null,      // 税务开户银行
        'billInfoBean.taxBankId': null,        // 税务开户银行账号
        'billInfoBean.taxAddress': null,        // 税务登记地址
        'billInfoBean.taxpaerType': null,
        coInsuranceCompanyList: [], // 共同被保人

        // 7008 平安货运无忧
        vehicleLicenceCode: '',
        vehicleFrameNo:'',
        useAttribute: null, // 使用性质 {key: '4', value: '营业'}, {key: '8', value: '非营业'},
        vehicle: null,      // 车辆种类 {key: '46', value: '货车'},{key: '47', value: '特种车'},
        vehicleDetail: null,  // 车辆类型
        licenseImageList: [], // 驾驶证影像件
        vehicleAddress: {
          residentProvince: '',
          residentProvinceName: '',
          residentCity: '',
          residentCityName: '',
          residentDistrict: '',
          residentDistrictName: '',
          detailAddress: '',
        },     // 车辆所属地区,
        factorRate: {},
        accidentRateValue: '',
        disabledRateValue: '',
        planCodesValue: '',
        withPlanList: [],
        withOrderList: [],
        otherOrderValue: {},
        otherPlanValue: {},
        factorRateAllSet: {},
        assembleError: false,

        factorRatePremiumRateList: null,
        additionalClauseInsured: null,
        conservationType: null,
        swimmingPoolInfo: {},
        // 代理人信息
        userMobile: '',
        userId: '',
        policySerialNumber: '',
        salesGroupPolicySn: '',
        totalAmount: 0,
        insureSuccessDate: '',
        ...writeStoreNew.state
    },
    getters: {
        shortRateByDuration: (state) => {
          let { productId, duration } = state
          let rate = 1
          // if (productId == '880') {
          //   if (duration.durationUnit == 'M' && duration.duration) {
          //     let durationVal = Number(duration.duration)
          //     if (durationVal <= 8) {
          //       rate = durationVal / 10
          //     } else if (durationVal == 9) {
          //       rate = 0.85
          //     } else if (durationVal == 10) {
          //       rate = 0.9
          //     } else if (durationVal == 11) {
          //       rate = 0.95
          //     }
          //   }
          // }
          return rate
        },
        productAddress: state => state.productAddress,
        // 建工险新增字段
        premiumData: state => state.premiumData,
        currentData: (state, getters) => {
          let params = {}
          // 责任
          if (getters.schemesInfo.length) {
            let schemesInfo = getters.schemesInfo[0]
            params.jobTypeClauseInfo = schemesInfo.jobTypeClauseInfo
            let schemesInfoAll = getters.schemesInfo
            const baseData = state.base || {};
            const frontControlInfo = state.frontControlInfo || {};
            // 数据转换 新的版本 60101
            if ([60101, 60102, 205].includes(Number(state.productId)) || state.frontControlInfo && (frontControlInfo.needToPremiumTrial || baseData.isCustomCalculate)) {
              let peopleNumALL = 0
              let samePrefessionPersonNum = 0
              params.jobTypeClauseInfo = {}
              params.allJobInfoTypes = []
              params.factorRate = {}
              for (let item of schemesInfoAll) {
                for (let keyItem in item.jobTypeClauseInfo) {
                  // if (item.personsInfo && item.personsInfo.length) {
                  //   let allNum = item.personsInfo.filter(pitem => pitem.occupationType === keyItem)
                  //   samePrefessionPersonNum = allNum.length
                  // } else {
                    let allNumList = item.professions.filter(pitem => pitem.occupationType === keyItem)
                    let num = 0
                    for(let pt of allNumList) {
                      num+=parseInt(pt.num)
                    }
                    samePrefessionPersonNum = num? num : parseInt(item.allNum)
                  // }
                  if (item.jobTypeClauseInfo && item.jobTypeClauseInfo[keyItem] && item.jobTypeClauseInfo[keyItem].length) {
                    item.jobTypeClauseInfo[keyItem][0].peopleNum = samePrefessionPersonNum
                  }

                  // 新增计划维度下的数据
                  if (item.withPlanList && item.withPlanList.length) {
                    item.withPlanList.map(oitem => {
                      item.jobTypeClauseInfo[keyItem].forEach(titem => {
                        titem[oitem.key] = oitem.selected ? oitem.selected.rate : oitem.factors [0].rate
                      })
                    })
                    // 单计划多职业 factorRate 数据初始化
                    if(state.frontControlInfo && !state.frontControlInfo.multiPlan && state.frontControlInfo.multiProfession) {
                      item.withPlanList.map(oitem => {
                        params.factorRate[oitem.key] = oitem.selected ? oitem.selected.rate : oitem.factors [0].rate
                      })
                    }
                  }

                }



              }
              for (let item of schemesInfoAll) {
                peopleNumALL+=parseInt(item.allNum)
                for(let pitemKey in item.jobTypeClauseInfo){
                  // if(params.jobTypeClauseInfo[pitemKey] && item.jobTypeClauseInfo[pitemKey]) {
                  //   params.jobTypeClauseInfo[pitemKey] = params.jobTypeClauseInfo[pitemKey].concat(item.jobTypeClauseInfo[pitemKey])
                  // } else {
                  //   params.jobTypeClauseInfo[pitemKey] = item.jobTypeClauseInfo[pitemKey]
                  // }
                  // 单计划 数据转换
                  if(state.frontControlInfo && !state.frontControlInfo.multiPlan && (frontControlInfo.needToPremiumTrial || baseData.isCustomCalculate)) {
                    let clauseInfoBeanList = []
                    item.jobTypeClauseInfo[pitemKey].forEach(planItem => {
                      clauseInfoBeanList.push(planItem)
                    })
                    let jobTypeClauseInfoNew = [{
                      clauseInfoBeanList: clauseInfoBeanList,
                      peopleNum: item.jobTypeClauseInfo[pitemKey] && item.jobTypeClauseInfo[pitemKey].length ? parseInt(item.jobTypeClauseInfo[pitemKey][0].peopleNum) : samePrefessionPersonNum,
                      productCombId: 1
                    }]
                    if (state.frontControlInfo.multiProfession) {
                      params.jobTypeClauseInfo[pitemKey] = jobTypeClauseInfoNew
                    } else {
                      if (params.jobTypeClauseInfo[pitemKey]) {
                        if (params.jobTypeClauseInfo[pitemKey][0].productCombId) {
                          params.jobTypeClauseInfo[pitemKey] = params.jobTypeClauseInfo[pitemKey].concat(item.jobTypeClauseInfo[pitemKey])
                        }
                      } else {
                        params.jobTypeClauseInfo[pitemKey] = item.jobTypeClauseInfo[pitemKey]
                      }
                    }
                  } else {
                    if (params.jobTypeClauseInfo[pitemKey]) {
                      if (params.jobTypeClauseInfo[pitemKey][0].productCombId) {
                        params.jobTypeClauseInfo[pitemKey] = params.jobTypeClauseInfo[pitemKey].concat(item.jobTypeClauseInfo[pitemKey])
                      }
                    } else {
                      params.jobTypeClauseInfo[pitemKey] = item.jobTypeClauseInfo[pitemKey]
                    }
                  }
                }
                // 新增获取职业code列表
                for(let proItem of item.professions){
                  if (!params.allJobInfoTypes.includes(proItem.code) && proItem.code) {
                    params.allJobInfoTypes.push(proItem.code)
                  }
                }
              }
              params.personNum = peopleNumALL
              params.personsNum = peopleNumALL
            } else {
              let peopleNumALL = 0
              for (let item of schemesInfoAll) {
                peopleNumALL+=parseInt(item.allNum)
              }
              params.personNum = peopleNumALL
              params.personsNum = peopleNumALL
            }
          } else {
            return
          }

          // if (getters.schemesInfo && getters.schemesInfo.length) {
          //   const jobTypeClauseInfo = {}
          //   for(let i in getters.schemesInfo) {
          //     for (let jobType in getters.schemesInfo[i].jobTypeClauseInfo) {
          //       if (!jobTypeClauseInfo[jobType]) {
          //         jobTypeClauseInfo[jobType] = []
          //         jobTypeClauseInfo[jobType].push(...getters.schemesInfo[i].jobTypeClauseInfo[jobType])
          //       } else {
          //         jobTypeClauseInfo[jobType].push(...getters.schemesInfo[i].jobTypeClauseInfo[jobType])
          //       }
          //     }
          //   }
          //   params.jobTypeClauseInfo = jobTypeClauseInfo
          // }
          if (!params.factorRate) {
            params.factorRate = {}
          }
          // 试算因子
          params.productId = state.productId
          params.projectType = state['constructionInfo.projectType']
          params.typeOfLabor = state['constructionInfo.typeOfLabor']
          // params.constructionPeriod = state['constructionInfo.constructionPeriod']
          params.constructionSquare = state['constructionInfo.constructionSquare'] ? Number(state['constructionInfo.constructionSquare']) : null
          // params.constructionStartTime = state['constructionInfo.constructionStartTime'] // 施工起期
          // params.constructionEndTime = state['constructionInfo.constructionEndTime'] // 施工止期
          params.constructionQualification = state['groupApplicant.constructionQualification']
          params.projectCosts = state['constructionInfo.projectCosts'] ? Number(state['constructionInfo.projectCosts']) : null
          params.area = state['constructionInfo.area']
          params.validStartDate = state['validStartDate']
          params.validEndDate = state['validEndDate']
          // 7008 平安货运无忧
          params.vehicleInfo = {}
          params.vehicleInfo.vehicleLicenceCode = state.vehicleLicenceCode
          params.vehicleInfo.vehicleFrameNo = state.vehicleFrameNo
          params.vehicleInfo.useAttribute = state.useAttribute && state.useAttribute.key ? state.useAttribute.key : ''
          params.vehicleInfo.vehicle = state.vehicle && state.vehicle.key ? state.vehicle.key : ''
          params.vehicleInfo.vehicleDetail = state.vehicleDetail && state.vehicleDetail.key ? state.vehicleDetail.key : ''
          params.vehicleInfo.licenseImageList = state.licenseImageList

          // 数据转换 新的版本 60101

          if (state['accidentRateValue'] || state['disabledRateValue'] || state['planCodesValue']) {
            if (!params.factorRate) {
              params.factorRate = {}
            }
            params.factorRate.accidentRate = state['accidentRateValue']
            params.factorRate.disabledRate = state['disabledRateValue']
            if (state['planCodesValue']) {
              params.factorRate.planCodes = state['planCodesValue']
            }
          }

          //保单维度的数据放入 factorRate
          if(state.withOrderList && state.withOrderList.length) {
            state.withOrderList.forEach(item => {
              params.factorRate[item.key] = item.selected ? item.selected.rate : item.factors[0].rate
            })
          }

          if (state.duration) {
            params.duration = state.duration.duration
            params.durationUnit = state.duration.durationUnit
          }

          if (state.groupName) {
            params.groupName = state.groupName
          }


          if([331].includes(Number(state.productId))) {
            params.factorRate = {
              planCodes: state.planCode
            }
            params.groupApplicant = {
              insureHouseProvince: state['groupApplicant.insureHouseProvince'],
              insureHouseCity: state['groupApplicant.insureHouseCity'],
              insureDistrict: state['groupApplicant.insureDistrict'],
              insureHouseProvinceName: state['groupApplicant.insureHouseProvinceName'],
              insureHouseCityName: state['groupApplicant.insureHouseCityName'],
              insureDistrictName: state['groupApplicant.insureDistrictName'],
              industryInfos: state['groupApplicant.industryInfos'],
            }
          }
          if([332].includes(Number(state.productId))) {
            params.factorRate = {
              planCodes: state.planCode
            }
          }


          if([336].includes(Number(state.productId))) {
            params.groupApplicant = {
              insureHouseProvince: state['groupApplicant.insureHouseProvince'],
              insureHouseCity: state['groupApplicant.insureHouseCity'],
              insureDistrict: state['groupApplicant.insureDistrict'],
              insureHouseProvinceName: state['groupApplicant.insureHouseProvinceName'],
              insureHouseCityName: state['groupApplicant.insureHouseCityName'],
              insureDistrictName: state['groupApplicant.insureDistrictName'],
              otherProvince: state['groupApplicant.otherProvince'],
              otherCity: state['groupApplicant.otherCity'],
              otherDistrict: state['groupApplicant.otherDistrict'],
              otherAddressName: state['groupApplicant.otherAddressName'],
            }
            params.groupCardType = state.groupCardType
            params.groupCardId = state.groupCardId
            // params.groupPolicyJobInfo = getters.submitParams.groupPolicyJobInfo || null
            // params.personsInfo = getters.submitParams.personsInfo || null
          }

          // 80124 写死逻辑 planCode 与 高空的数值转换
          if([80124].includes(Number(state.productId))) {
            console.log('currentData 80124 1', state.planCode)
            console.log('currentData 80124 2', state.withOrderList)
            let newPlanCode = '1'
            if(state.planCode == '1' && state.withOrderList[0].selected.rate == '1') {
              newPlanCode = '1'
            }
            if(state.planCode == '1' && state.withOrderList[0].selected.rate == '2') {
              newPlanCode = '2'
            }
            if(state.planCode == '2' && state.withOrderList[0].selected.rate == '1') {
              newPlanCode = '3'
            }
            if(state.planCode == '2' && state.withOrderList[0].selected.rate == '2') {
              newPlanCode = '4'
            }
            params.factorRate = {
              planCodes: newPlanCode
            }
            params.newPlanCode = newPlanCode
          }

          // 80218 游泳池信息
          if([80218].includes(Number(state.productId))) {
            params.constructionSquare = state.swimmingPoolInfo.swimmingPoolArea
            params.constructionNumber = state.swimmingPoolInfo.swimmingPoolCount
          }

          // 新增接口调用的数据
          if (trialControl && trialControl[state.productId + '']) {
            let trialControlData = trialControl[state.productId + '']
            if (!params.groupApplicant) {
              params.groupApplicant = {}
            }
            if (trialControlData.includes('insureHouseAddress')) {
              params.groupApplicant.insureHouseProvince = state['groupApplicant.insureHouseProvince']
              params.groupApplicant.insureHouseCity = state['groupApplicant.insureHouseCity']
              params.groupApplicant.insureDistrict = state['groupApplicant.insureDistrict']
              params.groupApplicant.insureHouseProvinceName = state['groupApplicant.insureHouseProvinceName']
              params.groupApplicant.insureHouseCityName = state['groupApplicant.insureHouseCityName']
              params.groupApplicant.insureDistrictName = state['groupApplicant.insureDistrictName']
            }
            if (trialControlData && trialControlData.includes('groupCardType')) {
              params.groupCardType = state.groupCardType
              params.groupApplicant.groupCardType = state.groupCardType
            }
            if (trialControlData && trialControlData.includes('groupCardId')) {
              params.groupCardId = state.groupCardId
              params.groupApplicant.groupCardId = state.groupCardId
            }
            if (trialControlData && trialControlData.includes('industryInfos')) {
              params.groupApplicant.industryInfos = state['groupApplicant.industryInfos']
            }
            if (trialControlData && trialControlData.includes('archiveInfo')) {
              params.groupApplicant.archiveInfo = getters.archiveInfo
            }
          }

          // 只为了数据监听调用而已
          if (state['otherPlanValue']) {}
          if (state['otherOrderValue']) {}

          return params
        },
        residentAddress(state) {
          let temp = {
            detailAddress: state['groupApplicant.address'],          // 团体联系人详细地址
            residentProvince: state['groupApplicant.residentProvince'], // 省
            residentCity: state['groupApplicant.residentCity'],     // 市
            residentDistrict: state['groupApplicant.residentDistrict'], // 区
            residentProvinceName: state['groupApplicant.residentProvinceName'], // 省
            residentCityName: state['groupApplicant.residentCityName'],     // 市
            residentDistrictName: state['groupApplicant.residentDistrictName'], // 区
          }
          return temp
        },
        vehicleAddress(state) {
          return state['vehicleAddress']
        },
        vehicleInfo(state,getters) {
          let temp = {
            vehicleLicenceCode: state.vehicleLicenceCode,
            vehicleFrameNo: state.vehicleFrameNo,
            useAttribute: state.useAttribute && state.useAttribute.key ? state.useAttribute.key : '',
            vehicle: state.vehicle && state.vehicle.key ? state.vehicle.key : '',
            vehicleDetail: state.vehicleDetail && state.vehicleDetail.key ? state.vehicleDetail.key : '',
            licenseImageList: state.licenseImageList,
            ...getters.vehicleAddress,
          }
          return temp
        },
        constructionInfo(state) {
          if (state.productId == 80218) {
            const swimmingPoolInfo = get(state, 'swimmingPoolInfo', {})
            return transformSwimmingPoolInfo2Jg(swimmingPoolInfo)
          }
          let temp = {
            projectName: state['constructionInfo.projectName'], // 工程名称
            projectType: state['constructionInfo.projectType'],
            typeOfLabor: state['constructionInfo.typeOfLabor'],
            constructionSquare: state['constructionInfo.constructionSquare'] ? Number(state['constructionInfo.constructionSquare']) : null,
            projectCosts: state['constructionInfo.projectCosts'] ? Number(state['constructionInfo.projectCosts']) : null,
            // constructionPeriod: state['constructionInfo.constructionPeriod'] ? Number(state['constructionInfo.constructionPeriod']) : null,
            constructionStartTime: state['constructionInfo.constructionStartTime'], // 施工起期
            constructionEndTime: state['constructionInfo.constructionEndTime'], // 施工止期
            area: state['constructionInfo.area'],
            materialImageUrls: state['constructionInfo.materialImageUrls'],
            notSafetySupervision: state['constructionInfo.notSafetySupervision'],
            constructionQualification: state['constructionInfo.constructionQualification'],
          }
          if (state.projectContractVideo && state.projectContractVideo.length) {
            temp.projectContractVideo = JSON.stringify(state.projectContractVideo)
          } else {
            temp.projectContractVideo = null
          }
          return temp
        },
        orderInfoExtendForm(state){
            const tagName = 'orderInfoExtend';
            let temp = {
                guestRoomAmount: state[`${tagName}.guestRoomAmount`],
                employeeAmount: state[`${tagName}.employeeAmount`],
                swimmingPoolAmount: state[`${tagName}.swimmingPoolAmount`],
                parkingLotAmount: state[`${tagName}.parkingLotAmount`],
                businessArea: state[`${tagName}.businessArea`],
            };
            return temp;
        },
        isNoProfession: state => {
          if (state.frontControlInfo && state.frontControlInfo.careerType.length == 1 && state.frontControlInfo.careerType[0] === '0') {
            return true
          } else {
            return false
          }
        },
        isAX: state => {
            if (state.frontControlInfo && state.frontControlInfo.isAX) {
                return true
            } else {
                return false
            }
        },
        personText(state) {
            if (state.frontControlInfo && state.frontControlInfo.personText) {
                return state.frontControlInfo.personText
            } else {
                return '被保人'
            }
        },
        maxApplyQuantityStr(state, getters) {
            if (getters.isAX && state.restrict && state.restrict.maxQuantity) {
                return '（最多' + state.restrict.maxQuantity +'份）'
            }
            return ''
        },
        maxPersonNumStr(state, getters) {
            if (getters.isAX && state.restrict && state.restrict.maxNum) {
                return '（最多' + state.restrict.maxNum +'人）'
            }
            return ''
        },
        archiveInfo: state => {
            let imgsBox = {}
            if (state.imgList && state.imgList.length > 0) {
              imgsBox.imgStatus = '1'
              imgsBox.url = state.imgList.join(',')
              // return '{"imgStatus":"1","url":"' + state.imgList.join(',') + '"}'
            }
            if (state.lastYearPolicyUrl && state.lastYearPolicyUrl.length) {
              imgsBox.lastYearPolicyUrl = state.lastYearPolicyUrl.join(',')
            }
            if (state.environmentUrl && state.environmentUrl.length) {
              imgsBox.environmentUrl = state.environmentUrl.join(',')
            }
            if (state.authorizationBookList && state.authorizationBookList.length) {
              imgsBox.authorizationBookList = state.authorizationBookList.join(',')
            }
            return JSON.stringify(imgsBox)
        },
        schemesInfo(state, getters) {
            // console.log('getting schemesInfo...')
            let schemesInfo = [];
            for (let i = 0; i < state.schemes.length; i++) {
                let scheme = state.schemes[i]
                schemesInfo.push(OrderFun.checkAndCalculateScheme(scheme, i, state, getters))
            }
            //价格前置
            schemesInfo = OrderFun.getTwiceTransformSchemesInfo(state, schemesInfo)
            return schemesInfo
        },
        submitParams: (state, getters) => {
            let submitParams = null
            let allNum = 0
            let newProfessions = []
            for (let schemeIndex = 0; schemeIndex < getters.schemesInfo.length; schemeIndex++) {
                const info = getters.schemesInfo[schemeIndex]
                newProfessions.push(info.professions)
                allNum += info.allNum
                if (!submitParams) {
                    submitParams = JSON.parse(JSON.stringify(info))

                    // 线下投保产品 老产品 提交资料书籍转换 start
                    let jobTypeClauseInfoNew = {}
                    if(state.frontControlInfo && !state.frontControlInfo.multiPlan && !state.frontControlInfo.needToPremiumTrial){
                      for (let jobType in info.jobTypeClauseInfo) {
                        // 非试算接口传参转换
                        let clauseInfoBeanList = []
                        submitParams.jobTypeClauseInfo[jobType].forEach(planItem => {
                          clauseInfoBeanList.push(planItem)
                        })
                        const professions_nums = info.professions.find(pp => pp.occupationType == jobType) || {}
                        let itemInfo = [{
                          clauseInfoBeanList: clauseInfoBeanList,
                        //   peopleNum: info.professions.find(pp => pp.occupationType == jobType).num,
                        peopleNum: professions_nums.num || 1,
                          productCombId: 1
                        }]
                        if (jobTypeClauseInfoNew[jobType] && jobTypeClauseInfoNew[jobType].length) {
                          jobTypeClauseInfoNew[jobType] = jobTypeClauseInfoNew[jobType].concat(itemInfo)
                        } else {
                          jobTypeClauseInfoNew[jobType] = itemInfo
                        }
                      }
                      submitParams.jobTypeClauseInfoNew = jobTypeClauseInfoNew
                    }
                    submitParams.allNum = allNum;
                    // 线下投保产品 老产品 提交资料书籍转换 end

                } else {
                    submitParams.allNum += info.allNum
                    //获取 免赔额 and 免赔率
                    if (info.deduction && info.deduction.length) {
                      submitParams.deduction.push(info.deduction[0])
                    }

                    for (let jobType in info.groupRuleInfo.jobTypeNumMap) {
                        if (submitParams.groupRuleInfo.jobTypeNumMap[jobType]) {
                            submitParams.groupRuleInfo.jobTypeNumMap[jobType] += info.groupRuleInfo.jobTypeNumMap[jobType]
                        } else {
                            submitParams.groupRuleInfo.jobTypeNumMap[jobType] = info.groupRuleInfo.jobTypeNumMap[jobType]
                        }
                    }

                    if (info.addPriceRange) {
                        for (let i = 0; i < info.addPriceRange.length; i++) {
                            submitParams.addPriceRange[i].maxPrice += info.addPriceRange[i].maxPrice
                            submitParams.addPriceRange[i].minPrice += info.addPriceRange[i].minPrice
                        }
                    }

                    if (info.priceRange) {
                        for (let i = 0; i < info.priceRange.length; i++) {
                            submitParams.priceRange[i].maxPrice += info.priceRange[i].maxPrice
                            submitParams.priceRange[i].minPrice += info.priceRange[i].minPrice
                        }
                    }

                    for (let jobInfo of info.groupPolicyJobInfo) {
                      if (state.frontControlInfo.multiPlanAndMultiProfession) { //开放性多计划
                        if (!submitParams.groupPolicyJobInfo.find(item => { return item.jobCode == jobInfo.jobCode && item.productCombId == jobInfo.productCombId && item.jobDesc == jobInfo.jobDesc})) {
                          submitParams.groupPolicyJobInfo.push(jobInfo)
                        }
                      } else { //限制性多计划
                        const multiPlanSupportSameProfessionAddMultiPlan = getObjVal(globalControlConfig, 'frontControlInfo.multiPlanSupportSameProfessionAddMultiPlan');
                        if (['80129'].includes(String(state.productId)) || multiPlanSupportSameProfessionAddMultiPlan) {
                          if (!submitParams.groupPolicyJobInfo.find(item => { return item.jobCode == jobInfo.jobCode && item.productCombId == jobInfo.productCombId})) {
                            submitParams.groupPolicyJobInfo.push(jobInfo)
                          }
                        } else {
                          if (!submitParams.groupPolicyJobInfo.find(item => { return item.jobCode == jobInfo.jobCode})) {
                            submitParams.groupPolicyJobInfo.push(jobInfo)
                          }
                        }

                      }
                    }

                    for (let jobType in info.jobTypeClauseInfo) {
                        if (submitParams.jobTypeClauseInfo[jobType]) {
                            if (submitParams.jobTypeClauseInfo[jobType][0].productCombId) {
                                submitParams.jobTypeClauseInfo[jobType] = submitParams.jobTypeClauseInfo[jobType].concat(info.jobTypeClauseInfo[jobType])
                            }
                        } else {
                            submitParams.jobTypeClauseInfo[jobType] = info.jobTypeClauseInfo[jobType]
                        }
                    }

                    submitParams.personsInfo = submitParams.personsInfo.concat(info.personsInfo)

                    submitParams.schemePersonNum += info.schemePersonNum
                    submitParams.price += info.price
                }
            }

            // 价格重置：复业报7002，前两个责任价格不与人数进行变动，这部分价格需要减除, IsPerPerson: 0-不加, 1-要加
            let schemePlanListHasIsPerPerson = state.schemes[0] && state.schemes[0].planList.find(item => item.isPerPerson === 0)
            if (schemePlanListHasIsPerPerson) {
              let copeSubmitParamsPrice = submitParams.price
              let jobTypeClauseInfoIndex = 0
              let isPerPersonPriceTol = 0
              for(let key in submitParams.jobTypeClauseInfo) {
                if (jobTypeClauseInfoIndex === 0) {
                  let plan = submitParams.jobTypeClauseInfo[key]
                  for(let index=0,len=plan.length; index<=len; index++) {
                    let premium = plan[index] && plan[index].isPerPerson === 0 ? plan[index].premium : 0
                    if (premium) {
                      isPerPersonPriceTol += premium
                    }
                  }
                }
                jobTypeClauseInfoIndex++
              }
              // console.log('isPerPersonPriceTol', isPerPersonPriceTol)
              submitParams.price = copeSubmitParamsPrice - (isPerPersonPriceTol * (submitParams.schemePersonNum - 1))
            }

            if (submitParams) {
                let discount = 1
                if (state.discountList && state.discountList.length > 0) {
                    for (const item of state.discountList) {
                        if (
                            (!item.minN || (item.minN && item.minN <= submitParams.allNum))
                            && (!item.maxN || (item.maxN && item.maxN >= submitParams.allNum))
                        ) {
                            discount = item.dicount;
                            break;
                        }
                    }
                }

                submitParams.discount = discount
                submitParams.price = submitParams.price * discount
                submitParams.price = parseFloat(submitParams.price.toFixed(2))

                // console.log('复保原折扣价格为: ', submitParams.price)
            }

            // 复保折扣价计算
            // 保费计算规则，比如：一个被保人投保意外身故保费51.2，医疗责任61.2，总人数101人，那么保费实际计算是（round（round（51.2）*0.95）+round（round（61.2）*0.95））*101
            let hasClauseDisCount = false
            try {
              for (let plan of getters.schemesInfo) {
                for (let jobType in plan.jobTypeClauseInfo) {
                  for (let job of plan.jobTypeClauseInfo[jobType]) {
                    if (job.clauseInfoBeanList && job.clauseInfoBeanList.length) {
                      for (let clause of job.clauseInfoBeanList) {
                        if (clause.disCountJson) {
                          hasClauseDisCount = true
                          break
                        }
                      }
                    }
                  }
                }
              }
            } catch (error) {

            }
            // console.log('hasClauseDisCount', hasClauseDisCount)
            if (submitParams && hasClauseDisCount) {
                let jobTypeNumMap = submitParams.groupRuleInfo.jobTypeNumMap
                submitParams.allNum = 0
                for (let jobType in jobTypeNumMap) {
                  submitParams.allNum += parseFloat(jobTypeNumMap[jobType])
                }

                let discount = 1, totalMoney = 0
                if (state.discountList && state.discountList.length > 0) {
                    for (const item of state.discountList) {
                        if (
                            (!item.minN || (item.minN && item.minN <= submitParams.allNum))
                            && (!item.maxN || (item.maxN && item.maxN >= submitParams.allNum))
                        ) {
                            discount = item.dicount;
                            break;
                        }
                    }
                }
                for (let schemeIndex = 0; schemeIndex < getters.schemesInfo.length; schemeIndex++) {
                  totalMoney += parseFloat(getters.schemesInfo[schemeIndex].disPrice)
                }

                submitParams.price = parseFloat(totalMoney.toFixed(2))
            }
            if (newProfessions && newProfessions.length) {
                submitParams.newProfessions = newProfessions
            }
            // 线下投保产品 老产品 提交资料书籍转换 start
            // if(state.base && state.base.productType &&  state.base.productType === 3 && submitParams.jobTypeClauseInfoNew && Object.keys(submitParams.jobTypeClauseInfoNew).length) {
            //     submitParams.jobTypeClauseInfo = submitParams.jobTypeClauseInfoNew
            // }
            // 线下投保产品 老产品 提交资料书籍转换 end
            return submitParams
        },
        priceInt : (state, getters) => {
            if (!getters.submitParams) {
                return 0
            }
            if (getters.submitParams.priceRange && getters.submitParams.priceRange.length) {
                let priceRangeItem = getters.submitParams.priceRange.find(item => {
                    return item.planCode == state.planCode
                })

                let price = getters.submitParams.price + (priceRangeItem.maxPrice - priceRangeItem.minPrice) * state.priceRate
                price = price.toFixed(2)
                return parseInt(price)
            } else {
                return parseInt(getters.submitParams.price)
            }
        },
        priceSmall : (state, getters) => {
            if (!getters.submitParams) {
                return '00'
            }
            console.log('priceSmall', getters.submitParams.priceRange);
            if (getters.submitParams.priceRange && getters.submitParams.priceRange.length) {
                let priceRangeItem = getters.submitParams.priceRange.find(item => {
                    return item.planCode == state.planCode
                })
                let price1 = _float(getters.submitParams.price + (priceRangeItem.maxPrice - priceRangeItem.minPrice) * state.priceRate)
                return price1.toFixed(2).split('.')[1]
                let price = getters.submitParams.price + (priceRangeItem.maxPrice - priceRangeItem.minPrice) * state.priceRate
                return price.toFixed(2).split('.')[1]
            } else {
                let price1 = _float(getters.submitParams.price);
                return price1.toFixed(2).split('.')[1]
                return getters.submitParams.price.toFixed(2).split('.')[1]
            }
        },
        schemePriceList(state, getters) {
            let schemePriceList = []
            for (let [schemeIndex, schemeInfo] of getters.schemesInfo.entries()) {
                let professionPriceList = []
                if (schemeInfo.priceRange && schemeInfo.priceRange.length) {
                    let priceRangeItem = schemeInfo.priceRange.find(item => {
                        return item.planCode == state.planCode
                    })
                    let schemePrice = schemeInfo.price + (priceRangeItem.maxPrice - priceRangeItem.minPrice) * state.priceRate
                    for (let professionPrice of schemeInfo.professionPriceList) {
                        professionPriceList.push(professionPrice / schemeInfo.price * schemePrice)
                    }

                    let personProfessionPlanPrice = []
                    if (['91','97', '98'].includes(String(state.productId))) {
                      let jobTypeClauseInfo = schemeInfo.jobTypeClauseInfo
                      let priceRate = state.priceRate
                      let clauseCodes = ['UPAP001', 'UPAP004'], extraCodes = ['UPAP005', 'UPAP006'];
                      if (priceRate) {
                        for (let jobtype in jobTypeClauseInfo) {
                          let cmps=0, cps=0, bmps=0, bps=0, extraAFlag = false, extraBFlag = false
                          for (let job of jobTypeClauseInfo[jobtype]) {
                            for (let item of job.clauseInfoBeanList) {
                              // console.log(item)
                              if (item.maxPremium) cmps += item.maxPremium
                              if (item.premium) cps += item.premium
                              if (item.id != 0 && clauseCodes.indexOf(item.duty)>-1) {
                                bmps += item.maxPremium
                                bps += item.premium
                              }
                              if (item.id != 0 && item.duty == 'UPAP005') {
                                extraAFlag = true
                              }
                              if (item.id != 0 && item.duty == 'UPAP006') {
                                extraBFlag = true
                              }
                            }
                          }
                          // console.log('priceRate',priceRate,',cmps',cmps,',cps',cps,',bmps',bmps,',bps',bps,',extraAFlag',extraAFlag,',extraBFlag',extraBFlag)
                          let extraBase = 0
                          if (extraAFlag) {
                            extraBase = bps*0.1+(bmps*0.1-bps*0.1)*priceRate;
                          }
                          if (extraBFlag) {
                            extraBase = bps*0.2+(bmps*0.2-bps*0.2)*priceRate;
                          }
                          personProfessionPlanPrice.push((cmps-cps)*priceRate+cps+extraBase)
                          // console.log(jobtype,'=',personProfessionPlanPrice)
                          // 设值
                        }
                      }
                    }
                    schemePriceList.push({
                        schemePrice,
                        professionPriceList,
                        personProfessionPlanPrice,
                    })
                } else {
                    schemePriceList.push({
                        schemePrice: schemeInfo.price,
                        professionPriceList: schemeInfo.professionPriceList
                    })
                }
            }
            return schemePriceList
        },
        extraClauseTotalAmount: (state, getters) => {
            if (!getters.submitParams) {
                return null
            }
            if (getters.submitParams.addPriceRange && getters.submitParams.addPriceRange.length) {
                let priceRangeItem = getters.submitParams.addPriceRange.find(item => {
                    return item.planCode == state.planCode
                })
                let price = priceRangeItem.minPrice + (priceRangeItem.maxPrice - priceRangeItem.minPrice) * state.priceRate
                return parseFloat(price.toFixed(2))
            } else {
                return null
            }
        },
        groupApplicant(state) {
            let temp = {
                setUpTime: state['groupApplicant.setUpTime'],        // 团体成立时间
                groupIdValidEndDate: state['groupApplicant.groupIdValidEndDate'],   // 营业执照止期
                groupCardLongTermEffective: state['groupApplicant.groupCardLongTermEffective'],
                concatCall: state['groupApplicant.concatCall'],       // 团体联系人电话
                groupContact: state['groupApplicant.groupContact'],     // 团体联系人
                groupNature: state['groupApplicant.groupNature'],      // 单位性质
                groupNatureCode: state['groupApplicant.groupNatureCode'],  // 单位性质id
                groupEmail: state['groupApplicant.groupEmail'],       // 联系人邮箱
                totalEmployers: state['groupApplicant.totalEmployers'],   // 上年末员工总数
                totalIncome: state['groupApplicant.totalIncome'],      // 上年度营业收入
                groupAssets: state['groupApplicant.groupAssets'],      // 上年末资产总额
                registersdFunds: state['groupApplicant.registersdFunds'],      // 公司注册资金
                companyCategory: state['groupApplicant.companyCategory'],      // 企业类别
                contactCall: state['groupApplicant.contactCall'],      // 联系人手机号
                landline: state['groupApplicant.landline'],      // 联系人座机号码
                contactCardId: state['groupApplicant.contactCardId'],    // 联系人身份证号
                operatorRelation: state['groupApplicant.operatorRelation'],      // 操作人和投保人关系

                /* 80212新增 */
                isHumanResources: state['groupApplicant.isHumanResources'],
                projectType: state['groupApplicant.projectType'],
                setUpTimeType: state['groupApplicant.setUpTimeType'],

                address: state['groupApplicant.address'],          // 团体联系人详细地址
                residentProvince: state['groupApplicant.residentProvince'], // 省
                residentCity: state['groupApplicant.residentCity'],     // 市
                residentDistrict: state['groupApplicant.residentDistrict'], // 区
                residentProvinceName: state['groupApplicant.residentProvinceName'], // 省
                residentCityName: state['groupApplicant.residentCityName'],     // 市
                residentDistrictName: state['groupApplicant.residentDistrictName'], // 区
                zipCode: state['groupApplicant.zipCode'],          // 邮政编码

                // 只有省市区的地址，不包含具体地址的地址组件字段
                otherProvinceName: state['groupApplicant.otherProvinceName'], //其他单位省名称
                otherCityName: state['groupApplicant.otherCityName'], //其他单位市名称
                otherDistrictName: state['groupApplicant.otherDistrictName'], //其他单位区名称
                otherProvince: state['groupApplicant.otherProvince'], //房屋地址区
                otherCity: state['groupApplicant.otherCity'], //房屋地址区
                otherDistrict: state['groupApplicant.otherDistrict'], //房屋地址区

                insureHouseAddress: state['groupApplicant.insureHouseAddress'], //房屋地址
                insureHouseInfo: state['groupApplicant.insureHouseInfo'],    //房屋地址省市区（中文）
                insureHouseProvince: state['groupApplicant.insureHouseProvince'], //房屋地址省份
                insureHouseCity: state['groupApplicant.insureHouseCity'], //房屋地址市
                insureDistrict: state['groupApplicant.insureDistrict'], //房屋地址区
                insureHouseProvinceName: state['groupApplicant.insureHouseProvinceName'], //房屋地址省份
                insureHouseCityName: state['groupApplicant.insureHouseCityName'], //房屋地址市
                insureDistrictName: state['groupApplicant.insureDistrictName'], //房屋地址区
                businessLicense: state['groupApplicant.businessLicense'], //营业执照
                insureHouseArea: state['groupApplicant.insureHouseArea'], //标的面积
                insureGroupCardId: state['groupApplicant.insureGroupCardId'],  //被保人证件号码
                insureGroupName: state['groupApplicant.insureGroupName'],  //被保人名称
                insureCompanyTypeCode: state['groupApplicant.insureCompanyTypeCode'], //被保人企业性质id
                insureCompanyType: state['groupApplicant.insureCompanyType'], //被保人企业性质
                businessArea: state['groupApplicant.businessArea'], //团体经营范围
                otherAddressName: state['groupApplicant.otherAddressName'], //
                industryInfos: state['groupApplicant.industryInfos'], //行业类型
                housingArea: state['groupApplicant.housingArea'],
                legalPersonIdNo: state['groupApplicant.legalPersonIdNo'], // 法人身份证号
            }

            // 建工险新增字段
            temp.constructionQualification = state['groupApplicant.constructionQualification'] // 施工资质
            if (state.constructionCertificate && state.constructionCertificate.length) {
              temp.constructionCertificate = JSON.stringify(state.constructionCertificate)
            } else {
              temp.constructionCertificate = null
            }
            if (state.legalPersonCardUrls && state.legalPersonCardUrls.length) {
                temp.legalPersonCardUrls = JSON.stringify(state.legalPersonCardUrls)
              } else {
                temp.legalPersonCardUrls = null
              }

            return temp
        },

        billInfoBean(state) {
            return {
                billType: state['billInfoBean.billType'],
                title: state['groupName'],                // 发票抬头
                amount: state['billInfoBean.amount'],               // 发票金额
                taxId: state['groupCardId'],                // 纳税人识别号或统一社会信用代码
                mailAddress: state['billInfoBean.mailAddress'],          // 电子邮箱地址
                address: state['billInfoBean.address'],              // 收件地址
                contactPerson: state['billInfoBean.contactPerson'],        // 收件人
                contactTel: state['billInfoBean.contactTel'],           // 联系电话
                province: state['billInfoBean.province'],
                city: state['billInfoBean.city'],
                zone: state['billInfoBean.zone'],
                provinceCode: state['billInfoBean.provinceCode'],
                cityCode: state['billInfoBean.cityCode'],
                zoneCode: state['billInfoBean.zoneCode'],
                taxTel: state['billInfoBean.taxTel'],           // 税务登记电话
                taxName: state['billInfoBean.taxName'],           // 纳税人姓名
                taxBankName: state['billInfoBean.taxBankName'],      // 税务开户银行
                taxBankId: state['billInfoBean.taxBankId'],        // 税务开户银行账号
                taxAddress: state['billInfoBean.taxAddress'],        // 税务登记地址
                taxpaerType: state['billInfoBean.taxpaerType'],        // 纳税人类型
            }
        },

        submitBillInfoBean(state, getters) {
            if (state['billInfoBean.billType'] == 200) {
                return getters.billInfoBean
            } else if (state['billInfoBean.billType'] == 201) {
                return getters.billInfoBean
                // return {
                //     billType: state['billInfoBean.billType']
                // }
            } else {
                return null
            }
        },
        ageRestrict(state) {
            const ageRestrictType = state.ageRestrictType;
            if(!ageRestrictType){
          return state.restrict && state.restrict.ageRestrict && !!JSON.parse(state.restrict.ageRestrict)
            } else {
                return false;
            }
        },
        ageRestrictObj(state) {
          const obj = {
            1: {}, // 男
            2: {}  // 女
          }
          if (state.restrict && state.restrict.ageRestrict) {
            if(!state.ageRestrictType){
            const ageRestrict = JSON.parse(state.restrict.ageRestrict)
            const man = ageRestrict.ageRestrict.find(item => item.isMan === 1)
            const waman = ageRestrict.ageRestrict.find(item => item.isMan === 0)
            try {
              obj[1].earliestBirthday = getEarliestBirthday(man.maxAge, state)
              obj[1].latestBirthday = getLatestBirthday(man.minAge, state)
              obj[1].minAge = man.minAge
              obj[1].maxAge = man.maxAge
              obj[2].earliestBirthday = getEarliestBirthday(waman.maxAge, state)
              obj[2].latestBirthday = getLatestBirthday(waman.minAge, state)
              obj[2].minAge = waman.minAge
              obj[2].maxAge = waman.maxAge
            } catch (error) {
              console.log('男女年龄限制报错', error)
            }
            }
          }
          return obj
        },
        //投保人最早出生日期（早于这个日期说明被保人年龄超过最大限度）
        earliestBirthday(state) {
            if (!state.restrict) {
                return ''
            }
            let earliestBirthday = new Date(state.validStartDate);
            if (state.frontControlInfo.ageCheckType === 'orderCreateDay') {
                let date = new Date()
                date.setHours(0)
                date.setMinutes(0)
                date.setSeconds(0)
                date.setMilliseconds(0)
                earliestBirthday = date
            }
            earliestBirthday.setFullYear(earliestBirthday.getFullYear() - state.restrict.maxAge - 1);
            earliestBirthday.setDate(earliestBirthday.getDate() + 1);
            return earliestBirthday.getTime();
        },
        //投保人最晚出生日期（晚于这个日期说明被保人年龄过小，不满足投保条件）
        latestBirthday(state) {
            // console.log(111111111, 'state.validStartDate', new Date(state.validStartDate))
            if (!state.restrict) {
                return ''
            }
            let latestBirthday = new Date(state.validStartDate);
            if (state.frontControlInfo.ageCheckType === 'orderCreateDay') {
                let date = new Date()
                date.setHours(0)
                date.setMinutes(0)
                date.setSeconds(0)
                date.setMilliseconds(0)
                latestBirthday = date
            }
            latestBirthday.setFullYear(latestBirthday.getFullYear() - state.restrict.minAge);
            // console.log(111111111, 'latestBirthday', new Date(latestBirthday))
            return latestBirthday.getTime();
        },
        pageSettings(state) {
            if (state.frontControlInfo) {
                const res = getPageSettingsSeparateToProductMsg(null, state.frontControlInfo);
                state.pageSettingsSeparate = res[0];
                let copyPageSettings = state.frontControlInfo.pageSettings.map(item => {
                  if (item.id == 'invoice' && state.productId == 1601) {
                    return {
                      id:"invoice",
                      index:70,
                      isShow:true,
                      title:"发票信息",
                      children: [
                        {
                          hideLabel:true,
                          label:"发票类型",
                          maxlength:50,
                          mode:"formInvoiceRadio",
                          needBillType:false,
                          placeholder:"请填写联系人姓名",
                        },
                        {
                          billType:"200",
                          label:"发票抬头",
                          mode:"formInput",
                          prop:"billInfoBean.title",
                          readonly:true,
                        },
                        {
                          billType:"200",
                          label:"纳税人识别号",
                          maxlength:20,
                          mode:"formInput",
                          placeholder:"纳税人识别号或统一社会信用代码",
                          prop:"billInfoBean.taxId",
                        },
                        {
                          billType:"200",
                          label:"电子邮箱",
                          mode:"formInput",
                          placeholder:"用于接收电子发票",
                          prop:"billInfoBean.mailAddress",
                          type:"email",
                        }
                      ]
                    }
                  }
                  if (item.id == 'insuredInfo' && state.productId == 7005) {
                    item.hide = 'detail, write, confirm'
                  }
                  return item
                })
                // console.log(copyPageSettings)
                return copyPageSettings //state.frontControlInfo.pageSettings
            } else {
                return []
            }
        },
        // 确认页和详情页使用 - index写死的排序
        pageSettingsSortedByIndex(state) {
            if (state.frontControlInfo) {
                let array = cloneDeep(state.frontControlInfo.pageSettings)

                array.sort((a, b) => {
                    return a.index - b.index
                })
                let copyArray = array
                return copyArray
            } else {
                return []
            }
        },
        // 确认页/详情页使用：过滤 invoice，新配置后台产品将 formPlan 替换为 formPlanNew
        pageSettingsForDetail(state, getters) {
            const configType = get(state, 'base.configType');
            const sorted = getters.pageSettingsSortedByIndex || [];
            const res = [];
            sorted.forEach(el => {
                if (el.id !== 'invoice') {
                    res.push(el);
                }
                if (+configType === 6) {
                    if (el.id === 'security') {
                        // 保障详情 - 将 formPlan 模式修改为 formPlanNew
                        el.children.forEach(child => {
                            if (child.mode === 'formPlan') {
                                child.mode = 'formPlanNew';
                            }
                        });
                    }
                }
            });
            return res;
        },
        productName(state) {
            if (!state.base) {
                return ''
            }
            return state.base.name + (state.base.shortDesc ? '（' + state.base.shortDesc + '）' : '')
        },
        premiumRate(state) {
            const isRepeatPremiumRateWithFactors = getObjVal(globalControlConfig, 'insurePageConfig.isRepeatPremiumRateWithFactors');
            if(isRepeatPremiumRateWithFactors && state.factorRatePremiumRateList && state.planCode) {
                const curs = state.factorRatePremiumRateList[state.planCode]
                if(curs) {
                    return curs.premiumRate
                }
            }
            if (!state.premiumRateList || !state.premiumRateList.length) {
                return 0
            }
            let item = state.premiumRateList.filter(item => {
                return item.planCode == state.planCode
            })[0]
            if (item) {
                return item.premiumRate
            } else {
                console.log('找不到planCode对应的推广费率')
                state.premiumRateList[0].premiumRate
            }
        },

        // 该getter 只有pc端才有
        billLimitType(state) {
            if (state.base && state.base.extInfo) {
                return JSON.parse(state.base.extInfo).billLimitType
            }
            return ''
        },

        addressSearchList(state) {
          return state.addressSearchList
        },
        productID(state) {
          return state.productId
        },
        ...writeStoreNew.getters
    },
    mutations: {
        setFactorRatePremiumRateList(state, val){
            state.factorRatePremiumRateList = val;
        },
        //此方法与app端不同
        save(state, val) {
            Vue.set(state, val.key, val.value)
            switch (val.key){
                case 'groupName':
                    state['billInfoBean.title'] = val.value;
                    break;
                case 'groupApplicant.groupEmail':
                    if (state.frontControlInfo.pageSettings && val.value) {
                        for (let item of state.frontControlInfo.pageSettings) {
                            for (let mode of item.children) {
                                if (mode.prop == 'billInfoBean.mailAddress' && (!state['billInfoBean.mailAddress'] || val.value.indexOf(state['billInfoBean.mailAddress']) > -1)) {
                                  state['billInfoBean.mailAddress'] = val.value
                                    break
                                }
                            }
                        }
                    }
                    break
                case 'billInfoBean.taxId':
                    state[val.key] = val.value.toUpperCase()
                    break;
                case 'groupApplicant.housingArea':
                    if (Number(val.value) > 500) state.insureHouseArea = 501
                    else state.insureHouseArea = 1
                    break;
                case 'groupName':
                      state['billInfoBean.title'] = val.value;
                      break;
                case 'groupCardId':
                    state['billInfoBean.taxId'] = val.value;
                    break;
                case 'planCode':
                  // 佣金率变化会影响保障计划中的选项，这里需要同步更新保障计划中的选项
                  // console.log('save planCode', val.value);
                  const cloneRules = cloneDeep(state.rules)
                  // console.log("🚀 ~ click_tag ~ cloneRules:", cloneRules)
                  cloneRules.forEach(rule => {
                    if (rule.multiRates && val.value) {
                      rule.rates = rule.multiRates[val.value]
                    }
                  })
                  state.rules = cloneRules
                  break;
            }
        },
        setAgeRestrictData(state, res){
            let data = getObjVal(res, 'restrict.ageRestrict');
            if(!data) {
                data = getObjVal(res, 'ageRestrict');
            }else{
                // res.restrict.ageRestrict = null;
            };
            if(data) {
                data = _toJson(data);
                state.ageRestrictType = data.ageRestrictType || 0;
                state.ageRestrictData = getObjVal(data, 'ageRestrict') || {};
            };
        },
        setBase(state, val) {
          // 去除重复的 营业执照与统一社会信用代码 只保留一个
          // if (val.cardType) {
          //   let cardType = JSON.parse(val.cardType)
          //   if (cardType.includes(4) && cardType.includes(5)) {
          //     val.cardType = JSON.stringify(lodashRemove(cardType, function(n) {
          //       return n !== 5;
          //     }))
          //   }
          //   console.log('val.cardType', val.cardType)
          // }
          state.base = val
        },
        setFactorRate(state, val) {
          state.factorRate = val
        },
        withPlanList(state, val) {
          state.withPlanList = val
        },
        withOrderList(state, val) {
          state.withOrderList = val
        },
        withOrderListSelectedUpdata(state, val) {
          Vue.set(state.withOrderList[val.index], 'selected', val.selected)
          Vue.set(state.withOrderList, val.index , state.withOrderList[val.index])
        },
        setInsureHouseArea(state, val) {
            state.insureHouseArea = val
        },
        setProductId(state, val) {
            state.productId = val
        },
        setDuration(state, val) {
            if (!val) {
                return
            }
            if (!val.duration || !val.durationUnit) {
                for (let item of state.durationList) {
                    if (item.durationDesc == val.durationDesc) {
                        val.duration = item.duration
                        val.durationUnit = item.durationUnit
                        break
                    }
                }
            }
            state.duration = val
        },
        setDurationByDurationAndUnit(state, val) {
            if (!val || !val.duration || !val.durationUnit) {
                return
            }
            for (let item of state.durationList) {
                if (item.duration == val.duration && item.durationUnit == val.durationUnit) {
                    state.duration = item
                    break
                }
            }
        },
        setDurationByOtherProduct(state, val) {
            if (!val) {
                return
            }
            let duration = null
            for (let item of state.durationList) {
                if (item.durationDesc == val.durationDesc) {
                    duration = item
                    break
                }
            }
            if (duration) {
                state.duration = duration
            }
        },
        // 设置团体信息
        setFormGroupInfo(state, data){
            _for(data, (el,key) => {
                if(_noValue(el)) return false;
                if(state[`groupApplicant.${key}`] !== void 0){
                    state[`groupApplicant.${key}`] = el;
                }

            })
        },
        setVehicleAddressOneByOne(state, data) {
          state['vehicleAddress'][data.key] = data.value
        },
        setVehicleAddress(state, data) {
          state['vehicleAddress'].residentProvince = data.selectAddress.province.code
          state['vehicleAddress'].residentProvinceName = data.selectAddress.province.name
          state['vehicleAddress'].residentCity = data.selectAddress.city.code
          state['vehicleAddress'].residentCityName = data.selectAddress.city.name
          state['vehicleAddress'].residentDistrict = data.selectAddress.area.code
          state['vehicleAddress'].residentDistrictName = data.selectAddress.area.name
          state['vehicleAddress'].detailAddress = data.textAddress
        },
        clearGroupAddress(state) {
          state['groupApplicant.residentProvince'] = ''
          state['groupApplicant.residentCity'] = ''
          state['groupApplicant.residentDistrict'] = ''
          state['groupApplicant.residentProvinceName'] = ''
          state['groupApplicant.residentCityName'] = ''
          state['groupApplicant.residentDistrictName'] = ''
          state['groupApplicant.address'] = ''
        },
        setGroupAddress(state, data) {
            state['groupApplicant.residentProvince'] = data.selectAddress.province.code
            state['groupApplicant.residentCity'] = data.selectAddress.city.code
            state['groupApplicant.residentDistrict'] = data.selectAddress.area.code
            state['groupApplicant.residentProvinceName'] = data.selectAddress.province.name
            state['groupApplicant.residentCityName'] = data.selectAddress.city.name
            state['groupApplicant.residentDistrictName'] = data.selectAddress.area.name
            state['groupApplicant.address'] = data.textAddress

            // 如果普票也需要填写地址，则把地址赋值给发票地址
            if (state.frontControlInfo.pageSettings) {
                for (let item of state.frontControlInfo.pageSettings) {
                    for (let mode of item.children) {
                        if (mode.prop == 'billInfoBean.address') {
                            if (data.textAddress && (!state.billInfoBean.address || data.textAddress.indexOf(state.billInfoBean.address) > -1)) {
                                state.billInfoBean.address = data.textAddress
                            }
                            if (!state.billInfoBean.provinceCode) {
                                state.billInfoBean.provinceCode = data.selectAddress.province.code
                                state.billInfoBean.province = data.selectAddress.province.name
                                state.billInfoBean.cityCode = data.selectAddress.city.code
                                state.billInfoBean.city = data.selectAddress.city.name
                                state.billInfoBean.zoneCode = data.selectAddress.area.code
                                state.billInfoBean.zone = data.selectAddress.area.name
                            }
                            break;
                        }
                    }
                }
            }
        },
        setConstructionInfoArea(state, data) {
          // console.log('watson', data)
          state['constructionInfo.area'].provinceCode = data.selectAddress.province.code
          state['constructionInfo.area'].provinceName = data.selectAddress.province.name
          state['constructionInfo.area'].cityCode = data.selectAddress.city.code
          state['constructionInfo.area'].cityName = data.selectAddress.city.name
          state['constructionInfo.area'].countyCode = data.selectAddress.area.code
          state['constructionInfo.area'].countyName = data.selectAddress.area.name
          state['constructionInfo.area'].address = data.textAddress
        },
        setHouseAddress(state, data) {
            if(!(data.selectAddress && data.selectAddress.province)) return;
            let insureHouseInfo = getObjVal(data, 'allAddress');
            if(!insureHouseInfo) {
                insureHouseInfo = data.selectAddress.province.name +
                data.selectAddress.city.name +
                data.selectAddress.area.name +
                data.textAddress
            }
            state['groupApplicant.insureHouseProvince'] = data.selectAddress.province.code
            state['groupApplicant.insureHouseCity'] = data.selectAddress.city.code
            state['groupApplicant.insureDistrict'] = data.selectAddress.area.code
            state['groupApplicant.insureHouseInfo'] = insureHouseInfo
            state['groupApplicant.insureHouseAddress'] = data.textAddress

            state['groupApplicant.residentProvinceName'] = data.selectAddress.province.name
            state['groupApplicant.residentCityName'] = data.selectAddress.city.name
            state['groupApplicant.residentDistrictName'] = data.selectAddress.area.name

            //lml-new
            state['groupApplicant.insureHouseProvinceName'] = data.selectAddress.province.name
            state['groupApplicant.insureHouseCityName'] = data.selectAddress.city.name
            state['groupApplicant.insureDistrictName'] = data.selectAddress.area.name
        },
        setOtherAddress(state, data) {
            // 只有省市区的地址，不包含具体地址的地址组件字段
            state['groupApplicant.otherProvinceName'] = data.selectAddress.province.name //其他单位省名称
            state['groupApplicant.otherCityName'] = data.selectAddress.city.name //其他单位市名称
            state['groupApplicant.otherDistrictName'] = data.selectAddress.area.name //其他单位区名称
            state['groupApplicant.otherProvince'] = data.selectAddress.province.code //房屋地址区
            state['groupApplicant.otherCity'] = data.selectAddress.city.code //房屋地址区
            state['groupApplicant.otherDistrict'] = data.selectAddress.area.code //房屋地址区
            state['groupApplicant.otherAddressName'] = get(data, 'otherAddressName', null)
        },
        setGroupApplicant(state, val) {
            if (!val) {
                return
            }
            for (let key in val) {
                state['groupApplicant.' + key] = val[key]
            }
            if (!(val['insureHouseProvince'] && val['insureHouseProvinceName'])) {
              state['groupApplicant.' + 'insureHouseProvince'] = ''
              state['groupApplicant.' + 'insureHouseProvinceName'] = ''
            }
            if (!(val['insureHouseCity'] && val['insureHouseCityName'])) {
              state['groupApplicant.' + 'insureHouseCity'] = ''
              state['groupApplicant.' + 'insureHouseCityName'] = ''
            }
            if (!(val['insureDistrict'] && val['insureDistrictName'])) {
              state['groupApplicant.' + 'insureDistrict'] = ''
              state['groupApplicant.' + 'insureDistrictName'] = ''
            }
        },
        setConstructionInfo(state, val) {
            if (!val) {
                return
            }
            for (let key in val) {
                state['constructionInfo.' + key] = val[key]
            }
        },

        // 该方法pc端专用
        setBillInfoBean(state, val) {
            if (!val) {
                return
            }
            for (let key in val) {
                state['billInfoBean.' + key] = val[key]
            }
        },
        // 该方法与app端不同
        setBillInfoAddress(state, data) {
            state['billInfoBean.provinceCode'] = data.selectAddress.province.code
            state['billInfoBean.province'] = data.selectAddress.province.name
            state['billInfoBean.cityCode'] = data.selectAddress.city.code
            state['billInfoBean.city'] = data.selectAddress.city.name
            state['billInfoBean.zoneCode'] = data.selectAddress.area.code
            state['billInfoBean.zone'] = data.selectAddress.area.name

            state['billInfoBean.address'] = data.textAddress
        },
        setClausePremium(state, val) {
            state.clausePremium = val
        },
        setCareerType(state, val) {
            state.careerType = val
        },
        setDiscountList(state, val) {
            state.discountList = val
        },
        setApplyQuantity(state, val) {
            state.applyQuantity = val
        },
        setImgList(state, val) {
            state.imgList = val
        },
        setAuthorizationBookList(state, val) {
          state.authorizationBookList = val
      },
        setConstructionCertificate(state, val) {
            state.constructionCertificate = val
        },
        setLegalPersonCardUrls(state, val) { // 法人代表身份证影像
            state.legalPersonCardUrls = val
        },

        // scheme相关
        setDefaultPlan(state, val) {
            state.defaultPlan = val
        },
        setSchemes(state, data) {
            state.schemes = JSON.parse(JSON.stringify(data))
            console.log('state.schemes1', state.schemes)
            Vue.set(state.schemes, JSON.parse(JSON.stringify(data)))
        },
        addNewScheme(state, pageName) {
            // 204 赔付比例默认值逻辑处理
            const deductibleRate = state.schemes && state.schemes[0] && state.schemes[0].deductibleRate
            const disabledRate = state.schemes && state.schemes[0] && state.schemes[0].disabledRate
            const factorRate = state.schemes && state.schemes[0] && state.schemes[0].factorRate
            let defaultPlan = ((state.productId == 97 || state.productId == 98) && state.schemes && state.schemes[0]) ? state.schemes[0] : state.defaultPlan
            // 有些产品会下架一些险种，后续不再售了，但是老产品的订单维度还是需要展示用户之前投保的
            // 订单详情页不需要过滤，因为订单详情页需要保留订单的责任数据
            if (DEPRECATED_CLAUSES_IDS[state.productId] && pageName !== 'orderDetail') {
              defaultPlan.planList = defaultPlan.planList.filter(
                item => !DEPRECATED_CLAUSES_IDS[state.productId].includes(item.clauseCode)
              )
            }
            let scheme = OrderFun.getNewScheme({
              firstOfCareeType: state.frontControlInfo.careerType[0],
              isAX: state.frontControlInfo.isAX,
              defaultPlan: defaultPlan,
              noProfessions: undefined,
              deductible: undefined,
              deductibleRate: state.productId == 204 ? deductibleRate : undefined,
              disabledRate: disabledRate ? disabledRate : undefined,
              factorRate: factorRate
            })
            state.schemes.push(JSON.parse(JSON.stringify(scheme)))
        },
        deleteScheme(state, data) {
            state.schemes.splice(data.schemeIndex, 1)
        },
        setSchemeProfession(state, data) {
            let profession = state.schemes[data.schemeIndex].professions[data.professionIndex]
            profession.val = data.profession.val
            profession.code = data.profession.code
            profession.des = data.profession.des
            // 选择职业之后，如果职业下有人员，也要更新人员的职业信息
            if (profession.personsInfo && profession.personsInfo.length) {
              profession.personsInfo.forEach(person => {
                person.occupationTypeVal = data.profession.val
                person.occupationType = getJobType(data.profession.val)
              })
            }
            Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
        },
        resetSchemePlanList(state, data) {
            let scheme = state.schemes[data.schemeIndex]

            let newPlanList = OrderFun.getNewPlanListByProfession(state.schemes, state.duration, state.clausePremium, state.frontControlInfo.isAX, data.schemeIndex, data.professionIndex)

            for (let [index, plan] of scheme.planList.entries()) {
                let sameInsured = newPlanList[index].insuredList.find(item => {
                    return item.insured == plan.selected.insured
                })

                plan.selected = newPlanList[index].insuredList[0] //sameInsured ? sameInsured : newPlanList[index].insuredList[0]
            }
            scheme.professions[data.professionIndex].val = data.profession.val
            scheme.professions[data.professionIndex].code = data.profession.code
            scheme.professions[data.professionIndex].des = data.profession.des
            Vue.set(state.schemes, data.schemeIndex, scheme)
        },
        addSchemeProfession(state, data) {
            let profession = OrderFun.getEmptyProfession()
            profession.val = data.profession.val
            profession.code = data.profession.code
            profession.des = data.profession.des
            state.schemes[data.schemeIndex].professions.push(profession)

            Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
        },
        deleteSchemeProfession(state, data) {
            state.schemes[data.schemeIndex].professions.splice(data.professionIndex, 1)
        },
        changeSchemePlanList(state, data) { // 产品详情页专用(为了把保额的可选／不可选状态同步到state中)
          for (let [index, plan] of state.schemes[data.schemeIndex].planList.entries()) {
              for (let insuredItem of plan.insuredList) {
                  if (insuredItem.insured == data.list[index].selected.insured) {
                      plan.selected = data.list[index].selected

                      // console.log('changeSchemePlanList-data', data)
                      if (data.curr && data.curr.attachPremium && state.frontControlInfo && state.frontControlInfo.careerType && state.frontControlInfo.careerType[0] === '0') {
                        let attachCondition = Picc.getAttachCondition(state, data)
                        // console.log('attachCondition', attachCondition)
                        let currPremiumInfo = attachCondition.premiumInfo.find(prem => prem.attachClause == plan.clauseCode)
                        if (currPremiumInfo) {
                          plan.selected = {
                            insured: currPremiumInfo.attachInsured,
                            nameStr: currPremiumInfo.rate == '10000' ? currPremiumInfo.attachInsured + '万元' : ((parseFloat(currPremiumInfo.attachInsured) * parseFloat(currPremiumInfo.rate)) + '元'),
                          }
                        }
                      }
                  }

                  // 设置保额的disabled属性
                  let theSameInsured = data.list[index].insuredList.find(item => {
                      return item.insured == insuredItem.insured
                  })
                  if (theSameInsured) {
                      insuredItem.disabled = theSameInsured.disabled
                  } else {
                      insuredItem.disabled = true
                  }
              }
          }
          Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
        },
        updateSchemePlanList(state, data) {
            // console.log(state, data)
            for (let [index, plan] of state.schemes[data.schemeIndex].planList.entries()) {
                for (let insuredItem of plan.insuredList) {
                    if (insuredItem.insured == data.list[index].selected.insured) {
                        plan.selected = data.list[index].selected

                        if (data.curr && data.curr.attachPremium && state.frontControlInfo && state.frontControlInfo.careerType && state.frontControlInfo.careerType[0] === '0') {
                          let attachCondition = Picc.getAttachCondition(state, data)
                          // console.log('attachCondition', attachCondition)
                          let currPremiumInfo = attachCondition.premiumInfo.find(prem => prem.attachClause == plan.clauseCode)
                          if (currPremiumInfo) {
                            plan.selected = {
                              insured: currPremiumInfo.attachInsured,
                              nameStr: currPremiumInfo.rate == '10000' ? currPremiumInfo.attachInsured + '万元' : ((parseFloat(currPremiumInfo.attachInsured) * parseFloat(currPremiumInfo.rate)) + '元'),
                            }
                          }
                        }
                        break
                    }
                }
            }
            Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
        },
        setSchemePlanListByPremiumList(state, data) {
            let scheme = state.schemes[data.schemeIndex]
            scheme = OrderFun.setSchemePlanListByPremiumList({
                state: state,
                scheme: scheme,
                premiumList: data.premiumList
            })
            Vue.set(state.schemes, data.schemeIndex, scheme)
        },
        setSchemeProfessionNum(state, data) {
            state.schemes[data.schemeIndex].professions[data.professionIndex].num = data.num
        },
        saveSchemeProfessionPerson(state, val) {
            if (val.person && val.person.insuredIdType == 1) {
                val.person.insuredIdNo = val.person.insuredIdNo.toUpperCase()
            }
            if (val.personIndex == undefined) {
                let length = state.schemes[val.schemeIndex].professions[val.professionIndex].personsInfo.unshift(val.person)

                if (length - 1 == state.schemes[val.schemeIndex].professions[val.professionIndex].num) {
                    state.schemes[val.schemeIndex].professions[val.professionIndex].num++
                }

                Vue.set(state.schemes, val.schemeIndex, state.schemes[val.schemeIndex])
            } else {
                Vue.set(state.schemes[val.schemeIndex].professions[val.professionIndex].personsInfo, val.personIndex, val.person)
            }
        },
        deleteSchemePerson(state, data) {
            let profession = state.schemes[data.schemeIndex].professions[data.professionIndex]
            profession.personsInfo.splice(data.personIndex, 1)
            if (profession.num - 1 == profession.personsInfo.length) {
                profession.num--
            }
            Vue.set(state.schemes[data.schemeIndex].professions, data.professionIndex, profession)
        },
        clearSchemePerson(state) {
          for (let index=0; index<state.schemes.length; index++) {
            let professions = state.schemes[index].professions
            let temp = []
            for (let idx = 0; idx<professions.length; idx++) {
              let profession = state.schemes[index].professions[idx]
              profession.num = 0
              profession.personsInfo = []
              // temp.push(profession)
            }
            // Vue.set(state.schemes[index], 'professions', temp)
          }
        },
        chooseAnxinPlan(state, data) {
            state.schemes[data.schemeIndex].planList = data.planList
        },
        setDb(state, data) {
            state.schemes[data.schemeIndex].deductible = data.val
        },
        setDbList(state, val) {
            state.dbList = val
        },
        setDr(state, data) {
            state.schemes[data.schemeIndex].deductibleRate = data.val
        },
        setDDr(state, data) {
          state.schemes[data.schemeIndex].disabledRate = data.val
        },
        setPlanCodeValues(state, data) {
          state.schemes[data.schemeIndex].planCodeRate = data.val
        },
        setDrList(state, val) {
            state.drList = val
        },
        setDDrList(state, val) {
          state.ddrList = val
        },
        setOtherPlanValue(state, data) {
          state.schemes[data.schemeIndex].withPlanList = data.withPlanList
          // Vue.set(state.schemes[data.schemeIndex], 'withPlanList', data.withPlanList)
          Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
          console.log('setOtherPlanValue schemes', state.schemes)
        },
        setOrderParams(state, data) {
            state.productId = data.productId
            state.applyQuantity = data.applyQuantity
            state.validStartDate = data.validStartDate
            state.insurePeriod = data.insurePeriod
            state.validEndDate = data.validEndDate?Number(data.validEndDate):data.validEndDate
            state.groupName = data.groupName
            state.legalPersonName = data.legalPersonName

            // 建工险新增字段
            let constructionInfo = undefined
            if (data.detailJson && JSON.parse(data.detailJson) && JSON.parse(data.detailJson).constructionInfo) {
              constructionInfo = JSON.parse(data.detailJson).constructionInfo
            } else if (data.constructionInfo) {
              constructionInfo = data.constructionInfo
            }
            if (constructionInfo && constructionInfo.projectContractVideo) {
              state.projectContractVideo = constructionInfo.projectContractVideo ? JSON.parse(constructionInfo.projectContractVideo) : []
            }

            //此处于pc端不同
            state['billInfoBean.title'] = data.groupName
            state['billInfoBean.taxId'] = data.groupCardId

            state.groupCardType = data.groupCardType
            state.groupCardId = data.groupCardId
            state.vehicleLicenceCode = data.vehicleLicenceCode
            state.vehicleFrameNo = data.vehicleFrameNo
            state.useAttribute = data.useAttribute
            state.vehicle = data.vehicle
            state.vehicleDetail = data.vehicleDetail
            state.licenseImageList = data.licenseImageList

            // 中邮录单特有字段
            state.userMobile = data.userMobile
            state.policySerialNumber = data.policySerialNumber
            state.salesGroupPolicySn = data.salesGroupPolicySn
            state.totalAmount = data.totalAmount
            state.insureSuccessDate = data.insureSuccessDate

            if (data.planCode) {
              let planCode = data.planCode
              // 205 planCode 转换 - 已下架
              // if(data.productId == '205') {
              //   planCode = Number(data.planCode) % 3
              //   if (planCode === 0) {
              //     planCode = 3
              //   }
              //   planCode = planCode + ''
              // }
              /* 
                * 2025-10-29 CMSX-5609 345平安团体无忧保(工标B版)下架第三个档位
                * 重新投保时，如果是已经被删除的档位，则不回填，取默认的
               */
              const availablePlanCode = getAvailablePlanCode(state.premiumRateList, planCode)
              if (availablePlanCode != state.planCode) {
                console.log('setOrderParams planCode', availablePlanCode);
                this.commit('save', {key: 'planCode', value: availablePlanCode})
              }
            }
            console.log("data.archiveInfo", data.archiveInfo)
            if (data.archiveInfo) {
                let archiveInfo = JSON.parse(data.archiveInfo)
                let url = archiveInfo.url
                let imgList = []
                if (url) {
                    imgList = url.split(',')
                }
                state.imgList = imgList

                if (archiveInfo.lastYearPolicyUrl) {
                  state.lastYearPolicyUrl = archiveInfo.lastYearPolicyUrl.split(',')
                }
                if (archiveInfo.environmentUrl) {
                  state.environmentUrl = archiveInfo.environmentUrl.split(',')
                }
                if (
                    archiveInfo.authorizationBookList &&
                    archiveInfo.authorizationBookList[0]
                ) {
                    state.authorizationBookList = archiveInfo.authorizationBookList[0].split(
                        ","
                    );
                } else if (archiveInfo && archiveInfo.authorizationBookList) {
                    state.authorizationBookList = archiveInfo.authorizationBookList.split(
                        ","
                    );
                }
            }

        },
        expendPersonInfo(state, data) {
            state.schemes[data.schemeIndex].professions[data.professionIndex].expend = !state.schemes[data.schemeIndex].professions[data.professionIndex].expend
            Vue.set(state.schemes[data.schemeIndex].professions, data.professionIndex, state.schemes[data.schemeIndex].professions[data.professionIndex])
        },
        openSchemePlanContent(state, data) {
            state.schemes[data.schemeIndex].planList[data.index].openContent = !state.schemes[data.schemeIndex].planList[data.index].openContent
            Vue.set(state.schemes[data.schemeIndex].planList, data.index, state.schemes[data.schemeIndex].planList[data.index])
        },
        openPlanSubdytyContent(state, data) {
            state.schemes[data.schemeIndex].planList[data.index].subDutys[data.subIndex].openContent = !state.schemes[data.schemeIndex].planList[data.index].subDutys[data.subIndex].openContent
            Vue.set(state.schemes[data.schemeIndex].planList[data.index], data.subIndex, state.schemes[data.schemeIndex].planList[data.index].subDutys[data.subIndex])
        },
        setSchemeProfessions(state, data) {
            state.schemes[data.schemeIndex].professions = data.professions
            Vue.set(state.schemes, data.schemeIndex, state.schemes[data.schemeIndex])
        },
        resetWriteStore(state) {
            let initialState = {
                productAddress: {},
                base: null,
                front: null,
                frontControlInfo: null,
                minRoleNum: '',
                description: null,
                restrict: null,
                durationList: [],
                schemes: [],
                defaultPlan: null,  //默认的投保计划
                rules: [],
                dbList: null,   // 免赔额列表
                drList: null,   // 赔付比例列表
                ddrList: null,   // 赔付比例列表
                clausePremium: null,    // 费率表
                careerType: [],    // 所有的职业列别
                discountList: [],   // 折扣列表
                premiumRateList: [],   // 费率列表
                planCode: null,   // 方案code
                priceRate: null,   // 浮动的保费 与 当前区间 的比例

                productId: null,
                duration: null,
                applyQuantity: 1,   // 投保份数
                validStartDate: '',
                validEndDate: '',
                insurePeriod: 0,
                groupName: '',
                legalPersonName: '',
                groupCardType: '',
                groupCardId: '',
                imgList: [],
                authorizationBookList: [],
                lastYearPolicyUrl: [],
                environmentUrl: [],

                // 建工险新增字段
                'constructionInfo.projectName': null,
                'constructionInfo.projectType': null,
                'constructionInfo.typeOfLabor': null,
                'constructionInfo.constructionSquare': null,
                'constructionInfo.projectCosts': null,
                'constructionInfo.constructionPeriod': null,
                'constructionInfo.constructionStartTime': null, // 施工起期
                'constructionInfo.constructionEndTime': null, // 施工止期
                'constructionInfo.area': {
                  provinceCode: '',
                  provinceName: '',
                  cityCode: '',
                  cityName: '',
                  countyCode: '',
                  countyName: '',
                  address: '',
                },
                projectContractVideo: [],
                constructionCertificate: [],
                'groupApplicant.constructionQualification': null,
                legalPersonCardUrls: [],

                'groupApplicant.concatCall': null,       // 团体联系人电话
                'groupApplicant.groupContact': null,     // 团体联系人
                'groupApplicant.groupNature': null,      // 单位性质
                'groupApplicant.groupNatureCode': null,  // 单位性质id
                'groupApplicant.groupEmail': null,       // 联系人邮箱
                'groupApplicant.totalEmployers': null,   // 上年末员工总数
                'groupApplicant.totalIncome': null,      // 上年度营业收入
                'groupApplicant.groupAssets': null,      // 上年末资产总额
                'groupApplicant.operatorRelation': null,      // 操作人和投保人关系
                /* 80212新增 */
                'groupApplicant.isHumanResources': null,  // 是否人力资源中介
                'groupApplicant.projectType': null,  // 项目类型
                'groupApplicant.setUpTimeType': null,  // 企业存续时间

                'groupApplicant.registersdFunds': null,      // 公司注册资金
                'groupApplicant.companyCategory': null,      // 企业类别

                'groupApplicant.contactCall': null,      // 联系人手机号
                'groupApplicant.landline': null,
                'groupApplicant.contactCardId': null,    // 联系人身份证号

                'groupApplicant.address': null,          // 团体联系人详细地址
                'groupApplicant.residentProvince': null, // 省
                'groupApplicant.residentCity': null,     // 市
                'groupApplicant.residentDistrict': null, // 区
                'groupApplicant.residentProvinceName': null, // 省名
                'groupApplicant.residentCityName': null,     // 市名
                'groupApplicant.residentDistrictName': null, // 区名

                'groupApplicant.otherProvinceName': null, //其他单位省名称
                'groupApplicant.otherCityName': null, //其他单位市名称
                'groupApplicant.otherDistrictName': null, //其他单位区名称
                'groupApplicant.otherProvince': null, //房屋地址区
                'groupApplicant.otherCity': null, //房屋地址区
                'groupApplicant.otherDistrict': null, //房屋地址区
                'groupApplicant.otherAddressName': null, //

                'groupApplicant.zipCode': null,          // 邮政编码
                'groupApplicant.insureHouseAddress': null, //房屋地址
                'groupApplicant.insureHouseInfo': null,    //房屋地址省市区（中文）
                'groupApplicant.insureHouseProvince': null, //房屋地址省份
                'groupApplicant.insureHouseCity': null, //房屋地址市
                'groupApplicant.insureDistrict': null, //房屋地址区
                'groupApplicant.insureHouseProvinceName': null, //房屋地址省份
                'groupApplicant.insureHouseCityName': null, //房屋地址市
                'groupApplicant.insureDistrictName': null, //房屋地址区
                'groupApplicant.businessLicense': null, //营业执照
                'groupApplicant.insureHouseArea': null, //标的面积
                'groupApplicant.insureGroupCardId': null,  //被保人证件号码
                'groupApplicant.insureGroupName': null,  //被保人名称
                'groupApplicant.insureCompanyTypeCode': null, //被保人企业性质id
                'groupApplicant.insureCompanyType': null, //被保人企业性质
                'groupApplicant.businessArea': null, //团体经营范围
                'groupApplicant.industryInfos': null, //行业类型
                'groupApplicant.housingArea': null,
                'groupApplicant.legalPersonIdNo': '', // 法人身份证号

                'billInfoBean.billType': null,
                'billInfoBean.title': null,                // 发票抬头
                'billInfoBean.amount': null,               // 发票金额
                'billInfoBean.taxId': null,                // 纳税人识别号或统一社会信用代码
                'billInfoBean.mailAddress': null,          // 电子邮箱地址
                'billInfoBean.address': null,              // 收件地址
                'billInfoBean.contactPerson': null,        // 收件人
                'billInfoBean.contactTel': null,           // 联系电话
                'billInfoBean.province': null,
                'billInfoBean.city': null,
                'billInfoBean.zone': null,
                'billInfoBean.provinceCode': null,
                'billInfoBean.cityCode': null,
                'billInfoBean.zoneCode': null,
                'billInfoBean.taxTel': null,           // 税务登记电话
                'billInfoBean.taxName': null,           // 纳税人姓名
                'billInfoBean.taxBankName': null,      // 税务开户银行
                'billInfoBean.taxBankId': null,        // 税务开户银行账号
                'billInfoBean.taxAddress': null,        // 税务登记地址
                'billInfoBean.taxpaerType': null,
                vehicleLicenceCode: '',
                vehicleFrameNo:'',
                useAttribute: '',
                vehicle: '',
                vehicleDetail: '',
                licenseImageList: [],
                vehicleAddress: {
                  residentProvince: '',
                  residentProvinceName: '',
                  residentCity: '',
                  residentCityName: '',
                  residentDistrict: '',
                  residentDistrictName: '',
                  detailAddress: '',
                },
                swimmingPoolInfo: {},
            }
            for (let key in initialState) {
                state[key] = initialState[key]
            }
        },
        addressSearchList(state, data) {
          state.addressSearchList = data.addressSearchList
        },
        setFactorRateValue(state, val) {
          for(let item in val) {
            state[item] = val[item]
          }
        },
        setProductDictionaryDTOJSON(state, val){
            state.productDictionaryDTOJSON = val
        },
        setSchemesProfessions(state, data) {
            state.schemes.forEach((scheme, index) => {
              scheme.professions = data[index]
            })
            console.log('setSchemesProfessions ****** end', state.schemes)
        },
        //民宿信息
        setOrderInfoExtend(state, data){
            // let orderInfoExtendForm = {};
            _for(data, (el, key) => {
                const tt = typeOf(el);
                if(tt === 'object') {
                    const {
                        value,
                        prop
                    } = el;
                    if(_noValue(value)) return false;
                    state[`orderInfoExtend.${prop}`] = value;
                    // orderInfoExtendForm[prop] = value;
                }else if(['number','string'].includes(tt)){
                    if(_noValue(el)) return false;
                    state[`orderInfoExtend.${key}`] = el;
                    // orderInfoExtendForm[key] = el;
                };
            });
            // state[`orderInfoExtendForm`] = orderInfoExtendForm;
        },
        setSwimmingPoolInfo(state, val) {
          state.swimmingPoolInfo = val
        },
        ...writeStoreNew.mutations
    },
    actions: {
        resetWriteStore({commit}){
            return new Promise((resolve, reject) => {
                commit('resetWriteStore')
                resolve()
            })
        },
        checkAndSaveSchemeProfessionPerson({commit, state, getters}, data) {
            return new Promise((resolve, reject) => {
                const ageRestrictType = state.ageRestrictType;
                let date = new Date(data.person.birthDay)
                date.setHours(0)
                date.setMinutes(0)
                date.setSeconds(0)
                date.setMilliseconds(0)
                date = date.getTime()

                let pid = String(state.productId)

                if (getters.isNewConfigType) {
                  // 新配置产品用新的校验年龄方法，其实只要服务端的数据结构一致，老的也能用，但是老的方法代码写的太疑惑了，尽量就不想去看了
                  const ageError = checkPersonAgeError({
                    person: data.person,
                    schemeIndex: data.schemeIndex,
                    professionIndex: data.professionIndex,
                    ageLimit: state.ageLimit,
                    restrict: state.restrict,
                    validStartDate: state.validStartDate,
                    personText: getters.personText || '被保人',
                  });
                  if (ageError) {
                    reject(ageError)
                    return
                  }
                } else if (getters.ageRestrict && getters.ageRestrictObj) { 
                  // 是否有设置不同的男女年龄限制 // 有
                  const latestBirthday = getters.ageRestrictObj[data.person.insuredSex].latestBirthday
                  const earliestBirthday = getters.ageRestrictObj[data.person.insuredSex].earliestBirthday
                  const minAge = getters.ageRestrictObj[data.person.insuredSex].minAge
                  const maxAge = getters.ageRestrictObj[data.person.insuredSex].maxAge
                  const ageErrorText = `被保人年龄不符合承保范围: ${minAge}-${maxAge}岁`
                  if ( date > latestBirthday || date < earliestBirthday) {
                    // this.$message.error(ageErrorText)
                    reject(ageErrorText)
                    return
                  }
                }else if(ageRestrictType === 1){
                    const ageRestrictData = state.ageRestrictData;
                    const person = data.person;
                    let errMsg = checkAgeRestrictByJobType({
                        ageRestrictData,
                        person,
                        validStartDate: state.validStartDate,
                    });
                    if(errMsg){
                        reject(errMsg)
                        return
                    }

                } else {
                  if (!['2001'].includes(pid) && (date < getters.earliestBirthday || date > getters.latestBirthday)) {
                    reject('被保人年龄不符合承保范围: ' + state.restrict.minAge + '-' + state.restrict.maxAge + '岁')
                    return
                  }
                }
                let samePerson = []
                // 新录入/修改 人员信息的时候判断是否输入相同人员信息
                for (let schemeIndex = 0; schemeIndex < state.schemes.length; schemeIndex++) {
                    let scheme = state.schemes[schemeIndex]
                    for (let professionIndex = 0; professionIndex < scheme.professions.length; professionIndex++) {
                        let personsInfo = scheme.professions[professionIndex].personsInfo
                        for (let personIndex = 0; personIndex < personsInfo.length; personIndex++) {
                            let item = personsInfo[personIndex]
                            if (schemeIndex == data.schemeIndex && professionIndex == data.professionIndex && personIndex == data.personIndex) {
                                continue
                            } else {
                                if (item.insuredIdType == data.person.insuredIdType && item.insuredIdNo == data.person.insuredIdNo) {
                                    samePerson.push(item)
                                    break
                                }
                            }
                        }
                        if (samePerson.length > 0) {
                            break
                        }
                    }
                    if (samePerson.length > 0) {
                        break
                    }
                }

                if (samePerson.length > 0) {
                    reject('被保人重复')
                    return
                }
                const specialValidateFunc = specialPersonValidateFuncMap[state.productId];
                if (specialValidateFunc) {
                  const specialValidateResult = specialValidateFunc({
                    productId: `${state.productId}`,
                    schemes: state.schemes,
                    currentScheme: state.schemes[data.schemeIndex],
                    singlePerson: data.person,
                    restrict: state.restrict,
                    validStartDate: state.validStartDate,
                    orderClauseList: state.orderClauseList,
                  });
                  if (specialValidateResult) {
                    reject(specialValidateResult)
                    return
                  }
                }
                commit('saveSchemeProfessionPerson', data)
                resolve()
            })
        },
        initStoreByOrderParams({commit, state}, params) {
          let detailJson = {}
          console.log('=== initStoreByOrderParams == ', params);
          try {
            if (params.detailJson) {
              detailJson = JSON.parse(params.detailJson || '{}')
            }
          } catch (e) {
            console.error('initStoreByOrderParam解析detailJson错误', e)
          }
            const isRepeatPremiumRateWithFactors = getObjVal
            return new Promise((resolve, reject) => {
                if (params.tempId) {
                    commit('save', {
                        key: 'unfinishStartDate',
                        value: params.validStartDate
                    })
                }
                if (params.history) {
                    commit('save', {
                        key: 'historyStartDate',
                        value: params.validStartDate
                    })
                }
                if (params.tempId && !params.unFinish) {
                    commit('addEmptyProfession')
                    console.log('该条数据是老数据')
                    resolve()
                    return
                }

                /* 共同被保险人 */
                if(params.coInsuranceCompanyList && params.coInsuranceCompanyList.length) {
                    state.coInsuranceCompanyList = params.coInsuranceCompanyList;
                }
                try{
                    if (params.recommend) {  //续保推荐
                        params.groupApplicant = {
                            groupContact: params.groupApplicant.groupContact ? params.groupApplicant.groupContact : null,
                            contactCall: params.groupApplicant.contactCall ? params.groupApplicant.contactCall : null,
                            landline: params.groupApplicant.landline ? params.groupApplicant.landline : null,
                            groupEmail: params.groupApplicant.groupEmail ? params.groupApplicant.groupEmail : null,
                        }
                    }

                    commit('setOrderParams', params)
                    commit('setAgeRestrictData', params)
                    // if (params.vehicleInfo) {
                    //   if (params.vehicleInfo.residentProvinceName) {
                    //     params.groupApplicant.residentProvinceName = params.vehicleInfo.residentProvinceName
                    //   }
                    //   if (params.vehicleInfo.residentCityName) {
                    //     params.groupApplicant.residentCityName = params.vehicleInfo.residentCityName
                    //   }
                    //   if (params.vehicleInfo.residentDistrictName) {
                    //     params.groupApplicant.residentDistrictName = params.vehicleInfo.residentDistrictName
                    //   }
                    // }
                    commit('setGroupApplicant', params.groupApplicant)

                    // 建工险新增
                    if (params.groupApplicant.constructionCertificate) {
                        commit('setConstructionCertificate', JSON.parse(params.groupApplicant.constructionCertificate))
                    }
                    if (params.groupApplicant.legalPersonCardUrls) {
                        commit('setLegalPersonCardUrls', JSON.parse(params.groupApplicant.legalPersonCardUrls))
                    }

                    // 民宿信息
                    if (params.orderInfoExtend) {
                        commit('setOrderInfoExtend', params.orderInfoExtend);
                    }

                    console.log('params.authorizationBookList', params.authorizationBookList)
                    if (params.authorizationBookList) {
                      commit('setAuthorizationBookList', params.authorizationBookList)
                    }

                    if (params.archiveInfo) {
                      let archiveInfo = JSON.parse(params.archiveInfo)
                      if (archiveInfo.authorizationBookList) {
                        commit('setAuthorizationBookList', archiveInfo.authorizationBookList.split(','))
                      }

                    }
                    // 80218 游泳池信息
                    if (['80218'].includes(params.productId + '')) {
                      if (params.swimmingPoolInfo) {
                        commit('setSwimmingPoolInfo', params.swimmingPoolInfo);
                      } else {
                        const constructionInfo = params.constructionInfo || detailJson.constructionInfo || {}
                        const swimmingPoolInfo = transformJg2SwimmingPoolInfo(constructionInfo)
                        commit('setSwimmingPoolInfo', swimmingPoolInfo)
                      }
                    }

                    // 7008
                    console.log('params.vehicleInfo', params.vehicleInfo)
                    if(params.vehicleInfo && ['7008'].includes(String(params.productId))) {
                      for(let key in params.vehicleInfo) {
                        let val = params.vehicleInfo[key]
                        let listKey = {
                          useAttribute:'USE_ATTRIBUTE_LIST',
                          vehicle:'VEHICLE_LIST',
                          vehicleDetail: ''
                        }[key]
                        if (key=='vehicleDetail'&&params.vehicleInfo['vehicle']==46) { // 货车
                          listKey = 'VEHICLE_DETSAIL_LIST_HUO'
                        } else if (key=='vehicleDetail'&&params.vehicleInfo['vehicle']==47) { //特种车
                          listKey = 'VEHICLE_DETSAIL_LIST_TE'
                        }
                        if (key == 'vehicle' || key == 'useAttribute' || key == 'vehicleDetail') {
                          console.log(listKey, val, {key, value: staticData[listKey].find(item => item.key == val)})
                          commit('save', {key, value: staticData[listKey].find(item => item.key == val)})
                        } else if (['detailAddress','residentCity','residentCityName','residentDistrict','residentDistrictName','residentProvince','residentProvinceName'].includes(key)) {
                          commit('setVehicleAddressOneByOne', {key, value: val})
                        } else {
                          commit('save', {key, value: val})
                        }
                      }
                    }

                    let constructionInfo = undefined
                    if (detailJson && detailJson.constructionInfo) {
                      constructionInfo = detailJson.constructionInfo
                    } else if (params.constructionInfo) {
                      constructionInfo = params.constructionInfo
                    }
                    commit('setConstructionInfo', constructionInfo)

                    commit('setBillInfoBean', params.billInfoBean)
                    if (!params.recommend) {
                        commit('setDuration', params.durationInfoBean)
                    } else {
                        commit('setDurationByOtherProduct', params.durationInfoBean)
                    }
                    console.log('paramsparamsparamsparams =====', params)
                    if(params.factorRate && params.factorRate.accidentRate!== undefined) {
                      commit('setFactorRateValue', {
                        accidentRateValue: params.factorRate.accidentRate
                      })
                    }

                    if(params.factorRate && params.factorRate.disabledRate!== undefined) {
                      commit('setFactorRateValue', {
                        disabledRateValue: params.factorRate.disabledRate
                      })
                    }

                    if(params.factorRate && params.factorRate.planCode!== undefined) {
                      commit('setFactorRateValue', {
                        planCodesValue: params.factorRate.planCode
                      })
                    }

                    if(params.factorRate && params.factorRate) {
                      commit('setFactorRateValue', {
                        factorRateAllSet: params.factorRate
                      })
                    }

                    if (params && params.newProfessions && params.newProfessions.length) {
                        commit('setSchemesProfessions', params.newProfessions)
                    }

                    // 数据更新
                    if (['332'].includes(params.productId + '') && params.factorRate) {
                      if (!params.factorRate.planCodes && params.planCode && params.productId == '332') {
                        params.factorRate.planCodes = params.planCode
                      }
                      if (params.factorRate.planCodes === '1') {
                        params.factorRate.planCodes = '1'
                        params.factorRate.planCodes2 = '2'
                      }
                      if (params.factorRate.planCodes === '2') {
                        params.factorRate.planCodes = '2'
                        params.factorRate.planCodes2 = '2'
                      }
                      if (params.factorRate.planCodes === '3') {
                        params.factorRate.planCodes = '3'
                        params.factorRate.planCodes2 = '2'
                      }
                      if (params.factorRate.planCodes === '4') {
                        params.factorRate.planCodes = '1'
                        params.factorRate.planCodes2 = '1'
                      }
                      if (params.factorRate.planCodes === '5') {
                        params.factorRate.planCodes = '2'
                        params.factorRate.planCodes2 = '1'
                      }
                    }
                    if (['80124'].includes(params.productId + '') && params.factorRate) {
                      if (params.planCode == '1') {
                        params.factorRate.planCodes = '1'
                      }
                      if (params.planCode == '2') {
                        params.factorRate.planCodes = '2'
                      }
                      if (params.planCode == '3') {
                        params.factorRate.planCodes = '1'
                      }
                      if (params.planCode == '4') {
                        params.factorRate.planCodes = '2'
                      }
                    }
                    if(['80210'].includes(params.productId + '')){
                        params.factorRate = params.factorRate || {};
                        if (!Object.keys(params.factorRate).length || params.factorRate && !params.factorRate.planCodes) {
                            if (params.planCode == 1) {
                                params.factorRate.planCodes = '1'
                            }else if(params.planCode == 2) {
                                params.factorRate.planCodes = '2'
                            }else if(params.planCode == 3) {
                                params.factorRate.planCodes = '1'
                            }else if(params.planCode == 4) {
                                params.factorRate.planCodes = '2'
                            };
                        };
                    };


                    let schemes = OrderFun.getSchemesByOrderParams(state, params)

                    // 905
                    console.log('params ========================', params)
                    if (params.planCodeRate && params.planCodeRate.length && params.factorRate) {
                      params.planCodeRate.forEach((element, index) => {
                        if (element && schemes[index]) {
                          if (schemes[index].professions.length > 1 && Array.isArray(element)) {
                            let findItem = element.find(oi => params.factorRate && oi.rate === params.factorRate.planCode)
                            let findNoItem = element.find(oi => params.factorRate && oi.rate !== params.factorRate.planCode)
                            let bindValue = {
                              disabled: false,
                              insured: findItem ? findItem.rate : findNoItem.rate,
                              nameStr: findItem ? findItem.desc : findNoItem.desc,
                              staticName: "",
                            }
                            schemes[index].planCodesValue = bindValue
                            schemes[index].planCodeRate = bindValue
                          } else {
                            let bindValue = {
                              disabled: false,
                              insured: element.rate,
                              nameStr: element.desc,
                              staticName: "",
                            }
                            schemes[index].planCodesValue = bindValue
                            schemes[index].planCodeRate = bindValue
                          }
                        }

                      });
                    }
                    // 数据初始化
                    // 保单维度的数据  计划维度的数据
                    // start
                    if(state.withOrderList && state.withOrderList.length) {
                      state.withOrderList.map(item => {
                        if (params.factorRate && params.factorRate[item.key]) {
                            const factorRateVal = params.factorRate[item.key];
                            if(item.type == 2) {
                                item.selected = {
                                    rate:  factorRateVal,
                                    desc: factorRateVal,
                                }
                            }else{
                          item.selected = item.factors.find(pitem => pitem.rate == params.factorRate[item.key])
                            }
                        }
                      })
                    }
                    if (state.withPlanList && state.withPlanList.length) {
                      for(let scheme of schemes) {
                        let findJobObj = params.groupPolicyJobInfo.find(item => item.productCombId == scheme.productCombId)
                        if (findJobObj) {
                          let findJobTypeClauseInfo = params.jobTypeClauseInfo[findJobObj.jobType]
                          if(findJobTypeClauseInfo) {
                            let findPlanJobInfo = findJobTypeClauseInfo.find(item => item.productCombId == scheme.productCombId)
                            if (scheme.withPlanList && scheme.withPlanList.length) {
                              let itemWithPlanList = cloneDeep(scheme.withPlanList)
                              for(let item of itemWithPlanList) {
                                // 其他维度元素 初始化
                                if(findPlanJobInfo[item.key]) {
                                  item.selected = item.factors.find(pitem => pitem.rate == findPlanJobInfo[item.key])
                                }
                              }
                              for(let item of itemWithPlanList) {
                                //factorRate 计划 保单维度元素 初始化
                                if (item.key && params.factorRate && params.factorRate[item.key]!==undefined) {
                                  item.selected = item.factors.find(pitem => pitem.rate == params.factorRate[item.key])
                                }
                              }
                              scheme.withPlanList = cloneDeep(itemWithPlanList)
                            }
                          }
                        }
                      }
                    }
                    // end
                    console.log('order schemes -------- ----', schemes)
                    /* 6346产品资料收集页面为回塞 */
                    _for(params.jobTypeClauseInfo,(clause_el)=>{
                        const tt = typeOf(clause_el)
                        if(tt === 'array'){
                            _for(clause_el, (clauseInfo)=>{
                                let clauseInfoBeanList = clauseInfo.clauseInfoBeanList || [];
                                OrderFun.selectedInsuredScheme(schemes, clauseInfoBeanList);
                            })
                        }
                    });
                    // _for(schemes, (sch_el)=>{
                    //     if(!sch_el.jobTypeClauseInfo && params.jobTypeClauseInfo){
                    //         _for(params.jobTypeClauseInfo,(clause_el)=>{
                    //             _for(clause_el, (clauseInfo)=>{
                    //                 let clauseInfoBeanList = clauseInfo.clauseInfoBeanList || [];
                    //                 OrderFun.selectedInsuredScheme(schemes, clauseInfoBeanList);
                    //             })
                    //         })
                    //     }
                    // })
                    // trace('schemes',schemes,params.jobTypeClauseInfo)
                    commit('setSchemes', cloneDeep(schemes))
                    console.log('schemes -------- ----', schemes)
                    resolve()
                } catch (error){
                    reject(error)
                }

            })
        },
        addressSearchList({commit, state}, params) {
          return new Promise((resolve, reject) => {
            commit('addressSearchList', params)
            resolve()
          })
        },
        ...writeStoreNew.actions
    }
}

export default writeStore



// WEBPACK FOOTER //
// ./src/store/modules/writeStore.js